/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Document custom scalar type for base64 or hex encoded content (e.g., PDFs, HTML, DOCX) */
  CustomDocument: { input: any; output: any; }
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: { input: any; output: any; }
  /** LocalDateTime custom scalar type */
  DelayLocalDateTimeResolver: { input: any; output: any; }
  /** Image custom scalar type */
  Image: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  OurDateTimeResolver: { input: any; output: any; }
  /** A local date string (i.e., with no associated timezone) in `YYYY-MM-DD` format, e.g. `2020-01-01`. */
  OurLocalDateResolver: { input: any; output: any; }
  /** LocalTime custom scalar type */
  OurTimeResolver: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  accountDeptDesc?: Maybe<Scalars['String']['output']>;
  accountDeptWebControl?: Maybe<Scalars['Float']['output']>;
  accountWebSetting: AccountWebSetting;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  address4?: Maybe<Scalars['String']['output']>;
  addresses: Array<Address>;
  allowDefaultAccountDept?: Maybe<Scalars['String']['output']>;
  allowDefaultOtherRef?: Maybe<Scalars['String']['output']>;
  analysisCode?: Maybe<Scalars['String']['output']>;
  analysisCode2?: Maybe<Scalars['String']['output']>;
  analysisCode3?: Maybe<Scalars['String']['output']>;
  bacsAccntType?: Maybe<Scalars['String']['output']>;
  bacsAccount?: Maybe<Scalars['String']['output']>;
  bacsAccountName?: Maybe<Scalars['String']['output']>;
  bacsMandateRef?: Maybe<Scalars['String']['output']>;
  bacsSortCode?: Maybe<Scalars['String']['output']>;
  bacsTrans?: Maybe<Scalars['Float']['output']>;
  bookingobjects?: Maybe<Scalars['String']['output']>;
  closed?: Maybe<Scalars['String']['output']>;
  compulsoryDept?: Maybe<Scalars['String']['output']>;
  compulsoryOtherRef?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Scalars['String']['output']>;
  contacts: Array<Contact>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  creditLimit?: Maybe<Scalars['Float']['output']>;
  currencyRef?: Maybe<Scalars['Float']['output']>;
  dateStartBacs?: Maybe<Scalars['DateTime']['output']>;
  defaultAccountDeptRef?: Maybe<Scalars['Float']['output']>;
  defaultAddressRef?: Maybe<Scalars['Float']['output']>;
  defaultDespInstructions?: Maybe<Scalars['String']['output']>;
  defaultMop?: Maybe<Scalars['String']['output']>;
  defaultPod?: Maybe<Scalars['String']['output']>;
  defaultSpecialInstructions?: Maybe<Scalars['String']['output']>;
  defaultTariff?: Maybe<Scalars['String']['output']>;
  delayGroup?: Maybe<Scalars['String']['output']>;
  depts: Array<AccountDept>;
  email?: Maybe<Scalars['String']['output']>;
  extraRefs: Array<AccountExtraRef>;
  extrarefReference?: Maybe<Scalars['Float']['output']>;
  extrarefSplitbyvalue?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  filterAccountDeptByGroups?: Maybe<Scalars['Float']['output']>;
  invAdd1?: Maybe<Scalars['String']['output']>;
  invAdd2?: Maybe<Scalars['String']['output']>;
  invAdd3?: Maybe<Scalars['String']['output']>;
  invAdd4?: Maybe<Scalars['String']['output']>;
  invCc?: Maybe<Scalars['String']['output']>;
  invContact?: Maybe<Scalars['String']['output']>;
  invContactCardRef?: Maybe<Scalars['Float']['output']>;
  invCountry?: Maybe<Scalars['String']['output']>;
  invEmail?: Maybe<Scalars['String']['output']>;
  invFao?: Maybe<Scalars['String']['output']>;
  invFax?: Maybe<Scalars['String']['output']>;
  invFrequency?: Maybe<Scalars['String']['output']>;
  invLayout?: Maybe<Scalars['String']['output']>;
  invLayoutcustom?: Maybe<Scalars['String']['output']>;
  invLayoutname?: Maybe<Scalars['String']['output']>;
  invName?: Maybe<Scalars['String']['output']>;
  invNote?: Maybe<Scalars['String']['output']>;
  invParentRef?: Maybe<Scalars['String']['output']>;
  invPostcode?: Maybe<Scalars['String']['output']>;
  invReadReceipt?: Maybe<Scalars['String']['output']>;
  invSendtype?: Maybe<Scalars['Float']['output']>;
  invSepCredit?: Maybe<Scalars['String']['output']>;
  invSurchargePc?: Maybe<Scalars['Float']['output']>;
  invTelephone?: Maybe<Scalars['String']['output']>;
  invType?: Maybe<Scalars['String']['output']>;
  jobFlags?: Maybe<Scalars['String']['output']>;
  jobInvAdd?: Maybe<Scalars['Float']['output']>;
  jobs: Array<Job>;
  manualPrice?: Maybe<Scalars['String']['output']>;
  maxInvoiceNet?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  numExtrarefs?: Maybe<Scalars['Float']['output']>;
  openedDt?: Maybe<Scalars['DateTime']['output']>;
  openedUser?: Maybe<Scalars['String']['output']>;
  otherRef?: Maybe<Scalars['String']['output']>;
  otherRefDesc?: Maybe<Scalars['String']['output']>;
  otherRefFormat?: Maybe<Scalars['String']['output']>;
  otherRefFrom?: Maybe<Scalars['String']['output']>;
  otherRefTo?: Maybe<Scalars['String']['output']>;
  overrideDepotRef?: Maybe<Scalars['Float']['output']>;
  overrideOoh?: Maybe<Scalars['String']['output']>;
  parentRef?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  priceBhols?: Maybe<Scalars['String']['output']>;
  priceGroup?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  stopped?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['Float']['output']>;
  termsDesc?: Maybe<Scalars['String']['output']>;
  useBacs?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  validateDept?: Maybe<Scalars['String']['output']>;
  vatCode?: Maybe<Scalars['String']['output']>;
  vatMethod?: Maybe<Scalars['String']['output']>;
  vatPercent?: Maybe<Scalars['Float']['output']>;
  vatRegistration?: Maybe<Scalars['String']['output']>;
  webReports: Array<WebReport>;
  website?: Maybe<Scalars['String']['output']>;
};


export type AccountAddressesArgs = {
  partial?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountContactsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountExtraRefsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountJobsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountDept = {
  __typename?: 'AccountDept';
  accountExtraRefRef?: Maybe<Scalars['Float']['output']>;
  accountRef?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  contactRefLink?: Maybe<ContactRefLink>;
  dateEnd?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  dateStart?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['String']['output']>;
  extraRef?: Maybe<AccountExtraRef>;
  info1?: Maybe<Scalars['String']['output']>;
  info2?: Maybe<Scalars['String']['output']>;
  info3?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  preventInvoicing?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
};

export type AccountExtraRef = {
  __typename?: 'AccountExtraRef';
  account: Account;
  accountRef?: Maybe<Scalars['String']['output']>;
  allowDefaultValue?: Maybe<Scalars['String']['output']>;
  allowedFormats?: Maybe<Scalars['String']['output']>;
  calculatedDefault?: Maybe<Scalars['String']['output']>;
  compulsory?: Maybe<Scalars['String']['output']>;
  defaultAccountDeptRef?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['String']['output']>;
  extraRefValues: Array<AccountDept>;
  filterByGroups?: Maybe<Scalars['Float']['output']>;
  maxLength?: Maybe<Scalars['Float']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  sortOrder?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
  validated?: Maybe<Scalars['String']['output']>;
  webSearchDdl?: Maybe<Scalars['Float']['output']>;
};


export type AccountExtraRefCalculatedDefaultArgs = {
  reference?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountWebSetting = {
  __typename?: 'AccountWebSetting';
  account?: Maybe<Account>;
  accountRef?: Maybe<Scalars['String']['output']>;
  allowSignUp?: Maybe<Scalars['Float']['output']>;
  contentColour?: Maybe<Scalars['String']['output']>;
  contentColourHex?: Maybe<Scalars['String']['output']>;
  contentFont?: Maybe<Scalars['String']['output']>;
  contentSize?: Maybe<Scalars['Float']['output']>;
  customCSS?: Maybe<Scalars['Float']['output']>;
  defaultContactIsPassenger?: Maybe<Scalars['String']['output']>;
  headerColour?: Maybe<Scalars['String']['output']>;
  headerColourHex?: Maybe<Scalars['String']['output']>;
  headerFont?: Maybe<Scalars['String']['output']>;
  headerSize?: Maybe<Scalars['Float']['output']>;
  leftHeaderPic?: Maybe<Scalars['Float']['output']>;
  priceIncTax?: Maybe<Scalars['String']['output']>;
  pwdAllowedChars?: Maybe<Scalars['String']['output']>;
  pwdExpiryNumDays?: Maybe<Scalars['Float']['output']>;
  pwdMaxFailedAttempts?: Maybe<Scalars['Float']['output']>;
  pwdMinLength?: Maybe<Scalars['Float']['output']>;
  pwdRequiredChars?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  rightHeaderPic?: Maybe<Scalars['Float']['output']>;
  signupCode?: Maybe<Scalars['String']['output']>;
  signupDefaultGroupRef?: Maybe<Scalars['Float']['output']>;
  signupDomain?: Maybe<Scalars['String']['output']>;
  signupName?: Maybe<Scalars['String']['output']>;
  signupPin?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type Address = {
  __typename?: 'Address';
  account?: Maybe<Account>;
  accountRef?: Maybe<Scalars['String']['output']>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  address4?: Maybe<Scalars['String']['output']>;
  addressName?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  contactRef?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  defaultAdd?: Maybe<Scalars['String']['output']>;
  gridX?: Maybe<Scalars['Float']['output']>;
  gridY?: Maybe<Scalars['Float']['output']>;
  invEmail?: Maybe<Scalars['String']['output']>;
  invFax?: Maybe<Scalars['String']['output']>;
  invSendType?: Maybe<Scalars['Float']['output']>;
  invTelephone?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  searchAddress?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AddressType>;
  typeRef?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
  zone?: Maybe<Scalars['String']['output']>;
};

export type AddressDefaults = {
  __typename?: 'AddressDefaults';
  account?: Maybe<Address>;
  contact?: Maybe<Address>;
};

export type AddressType = {
  __typename?: 'AddressType';
  addresses: Array<Address>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  reference: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
};


export type AddressTypeAddressesArgs = {
  partial?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type AddressWithType = {
  __typename?: 'AddressWithType';
  account?: Maybe<Account>;
  accountRef?: Maybe<Scalars['String']['output']>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  address4?: Maybe<Scalars['String']['output']>;
  addressName?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  contactRef?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  defaultAdd?: Maybe<Scalars['String']['output']>;
  gridX?: Maybe<Scalars['Float']['output']>;
  gridY?: Maybe<Scalars['Float']['output']>;
  invEmail?: Maybe<Scalars['String']['output']>;
  invFax?: Maybe<Scalars['String']['output']>;
  invSendType?: Maybe<Scalars['Float']['output']>;
  invTelephone?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  searchAddress?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AddressType>;
  typeCode: Scalars['String']['output'];
  typeRef?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
  zone?: Maybe<Scalars['String']['output']>;
};

export type Contact = {
  __typename?: 'Contact';
  accessAllContacts?: Maybe<Scalars['String']['output']>;
  accessList?: Maybe<Scalars['String']['output']>;
  accessListRead?: Maybe<Scalars['String']['output']>;
  account: Account;
  accountRef?: Maybe<Scalars['String']['output']>;
  addresses: Array<Address>;
  allowSub?: Maybe<Scalars['String']['output']>;
  allowSubRead?: Maybe<Scalars['String']['output']>;
  bookForContacts: Array<Contact>;
  bookForContactsCount: Scalars['Float']['output'];
  calculatedDefaultDespInst?: Maybe<Scalars['String']['output']>;
  calculatedDefaultJobFlags?: Maybe<Scalars['String']['output']>;
  calculatedDefaultMop?: Maybe<Scalars['String']['output']>;
  calculatedDefaultTariff?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  contactCards: Array<ContactCard>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactRefLinks: Array<ContactRefLink>;
  costCentre?: Maybe<Scalars['String']['output']>;
  createdDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  defaultAddressRef?: Maybe<Scalars['Float']['output']>;
  defaultBookerRef?: Maybe<Scalars['Float']['output']>;
  defaultCont?: Maybe<Scalars['String']['output']>;
  defaultContactCardRef?: Maybe<Scalars['Int']['output']>;
  defaultContactRef?: Maybe<Scalars['Float']['output']>;
  defaultDespInst?: Maybe<Scalars['String']['output']>;
  defaultInvAddRef?: Maybe<Scalars['Float']['output']>;
  defaultMop?: Maybe<Scalars['String']['output']>;
  defaultSpecialInst?: Maybe<Scalars['String']['output']>;
  defaultTariff?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  extraRefValues: Array<AccountDept>;
  extraRefs: Array<AccountExtraRef>;
  favouriteJourneys: Array<Job>;
  fax?: Maybe<Scalars['String']['output']>;
  intAddressFavourites: Array<IntFavourite>;
  intJobFavourites: Array<IntFavourite>;
  jobFlags?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  masqueradeAndMaintainContacts: Array<Contact>;
  masqueradeAndMaintainContactsCount: Scalars['Float']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  reportList: Array<WebReport>;
  telephone?: Maybe<Scalars['String']['output']>;
  universalAddresses: Array<AddressWithType>;
  uuid: Scalars['String']['output'];
  webAccess: WebAccess;
  webPassword?: Maybe<Scalars['String']['output']>;
  webReminder?: Maybe<Scalars['String']['output']>;
  webReports: Array<WebReport>;
  webUsername?: Maybe<Scalars['String']['output']>;
};


export type ContactAddressesArgs = {
  partial?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactBookForContactsArgs = {
  partial?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactContactCardsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactExtraRefValuesArgs = {
  accountExtraRefRef: Scalars['Int']['input'];
  partial?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactExtraRefsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactFavouriteJourneysArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactIntAddressFavouritesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactIntJobFavouritesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactMasqueradeAndMaintainContactsArgs = {
  partial?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactReportListArgs = {
  partial?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type ContactUniversalAddressesArgs = {
  partial?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ContactCard = {
  __typename?: 'ContactCard';
  addressMatched?: Maybe<Scalars['Int']['output']>;
  authenticationType?: Maybe<Scalars['Int']['output']>;
  avsVerifiedDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  cardTypeCode?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  contactRef?: Maybe<Scalars['Int']['output']>;
  cscMatched?: Maybe<Scalars['Int']['output']>;
  cvv2VerifiedDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  defaultCard?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['String']['output']>;
  encodedCardNumber?: Maybe<Scalars['String']['output']>;
  encryptedCardNumber?: Maybe<Scalars['String']['output']>;
  enhancedDataType?: Maybe<Scalars['Int']['output']>;
  enteredDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  jobCards?: Maybe<Array<JobCard>>;
  lastFourCharacters?: Maybe<Scalars['String']['output']>;
  lastTransDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  nameOnCard?: Maybe<Scalars['String']['output']>;
  originCountryCode?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['Int']['output']>;
  postcodeMatched?: Maybe<Scalars['Int']['output']>;
  providerId?: Maybe<Scalars['Int']['output']>;
  providerInfo?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  securityNumber?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenExpiryUtc?: Maybe<Scalars['OurDateTimeResolver']['output']>;
  tokenType?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
  validFrom?: Maybe<Scalars['String']['output']>;
  validTo?: Maybe<Scalars['String']['output']>;
};


export type ContactCardJobCardsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ContactDetail = {
  __typename?: 'ContactDetail';
  contactMethod?: Maybe<Scalars['String']['output']>;
  contactNotes?: Maybe<Scalars['String']['output']>;
  contactType?: Maybe<Scalars['String']['output']>;
  contactValue?: Maybe<Scalars['String']['output']>;
  parentPrimaryKey?: Maybe<Scalars['String']['output']>;
  parentTableName: Scalars['String']['output'];
  reference: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
};

export type ContactRefLink = {
  __typename?: 'ContactRefLink';
  accountDept?: Maybe<AccountDept>;
  accountDeptRef?: Maybe<Scalars['Float']['output']>;
  accountExtraRefRef?: Maybe<Scalars['Float']['output']>;
  contact: Contact;
  contactRef?: Maybe<Scalars['Float']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
};

export type CountriesOverride = {
  __typename?: 'CountriesOverride';
  accountRef?: Maybe<Scalars['String']['output']>;
  contactRef?: Maybe<Scalars['Int']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryDescription?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
};

export type Country = {
  __typename?: 'Country';
  code?: Maybe<Scalars['String']['output']>;
  currencyRef?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['String']['output']>;
  ec?: Maybe<Scalars['String']['output']>;
  iso2?: Maybe<Scalars['String']['output']>;
  iso3?: Maybe<Scalars['String']['output']>;
  isoNum?: Maybe<Scalars['Int']['output']>;
  reference: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
};

export type Currency = {
  __typename?: 'Currency';
  calcPurchaseRate?: Maybe<Scalars['Float']['output']>;
  calcSalesRate?: Maybe<Scalars['Float']['output']>;
  calculatedDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  currencyRates: Array<CurrencyRate>;
  descripton?: Maybe<Scalars['String']['output']>;
  disablePurchase?: Maybe<Scalars['String']['output']>;
  disableSales?: Maybe<Scalars['String']['output']>;
  downloadDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  liveRate?: Maybe<Scalars['Float']['output']>;
  purchaseAdj?: Maybe<Scalars['String']['output']>;
  purchaseOverrideAdj?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  salesAdj?: Maybe<Scalars['String']['output']>;
  salesOverrideAdj?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};


export type CurrencyCurrencyRatesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CurrencyRate = {
  __typename?: 'CurrencyRate';
  adjustmentRef?: Maybe<Scalars['Float']['output']>;
  createdDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  currency?: Maybe<Currency>;
  currencyRef?: Maybe<Scalars['Float']['output']>;
  purchaseAdj?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  reference: Scalars['ID']['output'];
  salesAdj?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type DefaultExtra = {
  __typename?: 'DefaultExtra';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  jobExtras: Array<JobExtra>;
  reference: Scalars['ID']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  warnCharging?: Maybe<Scalars['String']['output']>;
  warnPricing?: Maybe<Scalars['String']['output']>;
};

export type Delay = {
  __typename?: 'Delay';
  criteria?: Maybe<Scalars['String']['output']>;
  delay?: Maybe<Scalars['Float']['output']>;
  delayFunctRef?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['String']['output']>;
  functActiveFromUtc?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  functActiveToUtc?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  preventJob?: Maybe<Scalars['Float']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  revision?: Maybe<Scalars['Float']['output']>;
  sortOrder?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type Document = {
  __typename?: 'Document';
  createdDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  createdUser?: Maybe<Scalars['String']['output']>;
  customId?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  documentObjs?: Maybe<Array<DocumentObj>>;
  documentType?: Maybe<DocumentType>;
  job?: Maybe<Job>;
  notificationStatus?: Maybe<Scalars['Float']['output']>;
  reference: Scalars['ID']['output'];
  relatedRecord?: Maybe<Scalars['String']['output']>;
  relatedTable?: Maybe<Scalars['String']['output']>;
  sentDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  typeRef?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
  validFrom?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  validTo?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
};


export type DocumentDocumentObjsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  typeCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DocumentObj = {
  __typename?: 'DocumentObj';
  compressType?: Maybe<Scalars['String']['output']>;
  customId?: Maybe<Scalars['Float']['output']>;
  dataUri?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  docBinary?: Maybe<Scalars['CustomDocument']['output']>;
  docSize?: Maybe<Scalars['Float']['output']>;
  document?: Maybe<Document>;
  documentRef?: Maybe<Scalars['Float']['output']>;
  reference: Scalars['ID']['output'];
  sortOrder?: Maybe<Scalars['Float']['output']>;
  typeCode?: Maybe<Scalars['String']['output']>;
  typeDesc?: Maybe<Scalars['String']['output']>;
  uncompressSize?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type DocumentType = {
  __typename?: 'DocumentType';
  allocationAction?: Maybe<Scalars['Float']['output']>;
  associatedField?: Maybe<Scalars['String']['output']>;
  associatedTable?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  compulsory?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Float']['output']>;
  documents: Array<Document>;
  externalVisible?: Maybe<Scalars['Float']['output']>;
  reference: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
  validation?: Maybe<Scalars['Float']['output']>;
  validationField?: Maybe<Scalars['String']['output']>;
  warnDays?: Maybe<Scalars['Float']['output']>;
};


export type DocumentTypeDocumentsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type Driver = {
  __typename?: 'Driver';
  addrGridX?: Maybe<Scalars['Float']['output']>;
  addrGridY?: Maybe<Scalars['Float']['output']>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  address4?: Maybe<Scalars['String']['output']>;
  agentDriverRef?: Maybe<Scalars['String']['output']>;
  agentRef?: Maybe<Scalars['Int']['output']>;
  allocationCriteriaRefs?: Maybe<Scalars['String']['output']>;
  bankAccount?: Maybe<Scalars['String']['output']>;
  bankSortCode?: Maybe<Scalars['String']['output']>;
  buildingSocRoleNo?: Maybe<Scalars['String']['output']>;
  callsign?: Maybe<Scalars['String']['output']>;
  chargeGroup?: Maybe<Scalars['String']['output']>;
  commissionCalcType?: Maybe<Scalars['Int']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  currencyRef?: Maybe<Scalars['Int']['output']>;
  dateBirth?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  dateLeft?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  dateLicenseExpires?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  dateOLicenseExpires?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  datePassedTest?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  dateStarted?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  depotRef?: Maybe<Scalars['Int']['output']>;
  driverFlags?: Maybe<Scalars['String']['output']>;
  ediPayments?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  holdRefunds?: Maybe<Scalars['String']['output']>;
  initials?: Maybe<Scalars['String']['output']>;
  invAddress1?: Maybe<Scalars['String']['output']>;
  invAddress2?: Maybe<Scalars['String']['output']>;
  invAddress3?: Maybe<Scalars['String']['output']>;
  invAddress4?: Maybe<Scalars['String']['output']>;
  invCC?: Maybe<Scalars['String']['output']>;
  invCountry?: Maybe<Scalars['String']['output']>;
  invEmail?: Maybe<Scalars['String']['output']>;
  invFao?: Maybe<Scalars['String']['output']>;
  invFrequency?: Maybe<Scalars['String']['output']>;
  invLayout?: Maybe<Scalars['String']['output']>;
  invLayoutCustom?: Maybe<Scalars['String']['output']>;
  invLayoutName?: Maybe<Scalars['String']['output']>;
  invName?: Maybe<Scalars['String']['output']>;
  invPostcode?: Maybe<Scalars['String']['output']>;
  invReadReceipt?: Maybe<Scalars['String']['output']>;
  invType?: Maybe<Scalars['String']['output']>;
  latestJobRef?: Maybe<Scalars['Int']['output']>;
  leavingReason?: Maybe<Scalars['String']['output']>;
  license?: Maybe<Scalars['String']['output']>;
  loggedOn?: Maybe<Scalars['String']['output']>;
  mobileDataId?: Maybe<Scalars['Int']['output']>;
  mobileDataLastDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  ni?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  oLicenceNumber?: Maybe<Scalars['String']['output']>;
  overrideCompany?: Maybe<Scalars['String']['output']>;
  pagerNo?: Maybe<Scalars['String']['output']>;
  payrollRef?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Picture>;
  planningGroup?: Maybe<Scalars['String']['output']>;
  plotRef?: Maybe<Scalars['Int']['output']>;
  plotRevision?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  preventAllocation?: Maybe<Scalars['String']['output']>;
  purchSendType?: Maybe<Scalars['Int']['output']>;
  reference: Scalars['ID']['output'];
  revision?: Maybe<Scalars['Int']['output']>;
  shiftGroup?: Maybe<Scalars['String']['output']>;
  shiftRef?: Maybe<Scalars['Int']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  telHome?: Maybe<Scalars['String']['output']>;
  telMobile?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trackingId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  vatCode?: Maybe<Scalars['String']['output']>;
  vatMethod?: Maybe<Scalars['String']['output']>;
  vatReg?: Maybe<Scalars['String']['output']>;
  vehicleClass?: Maybe<Scalars['String']['output']>;
  vehicleColour?: Maybe<Scalars['String']['output']>;
  vehicleDescription?: Maybe<Scalars['String']['output']>;
  vehicleRef?: Maybe<Scalars['String']['output']>;
  vehicleType?: Maybe<Scalars['String']['output']>;
  visaCountryCode?: Maybe<Scalars['String']['output']>;
  visaExpiryDate?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  visaType?: Maybe<Scalars['String']['output']>;
};


export type DriverPhotoArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type Event = {
  __typename?: 'Event';
  appliesTo?: Maybe<Scalars['Int']['output']>;
  applyType?: Maybe<Scalars['Int']['output']>;
  availableFields?: Maybe<Scalars['String']['output']>;
  clearStatusFlags?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  criteriaRefs?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Int']['output']>;
  eventObjectId?: Maybe<Scalars['Int']['output']>;
  eventTextPrompt?: Maybe<Scalars['String']['output']>;
  jobEvents: Array<JobEvent>;
  reference: Scalars['ID']['output'];
  setStatusFlags?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  statusFlag?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
};

export type Flag = {
  __typename?: 'Flag';
  allowPlanning?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['String']['output']>;
  flagId?: Maybe<Scalars['Int']['output']>;
  flagType?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
};

export type GoFlowHeader = {
  __typename?: 'GoFlowHeader';
  code?: Maybe<Scalars['String']['output']>;
  criteriaRefs?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  disabled?: Maybe<Scalars['Int']['output']>;
  guest?: Maybe<Scalars['Int']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  revision?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
};

export type Good = {
  __typename?: 'Good';
  code?: Maybe<Scalars['String']['output']>;
  code2?: Maybe<Scalars['String']['output']>;
  consignmentRef?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionSearch?: Maybe<Scalars['String']['output']>;
  dropStop?: Maybe<Scalars['Int']['output']>;
  flagRefs?: Maybe<Scalars['String']['output']>;
  goodsAvailableDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  goodsExpectedDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  goodsFlags: Array<GoodsFlag>;
  info1?: Maybe<Scalars['String']['output']>;
  info2?: Maybe<Scalars['String']['output']>;
  info3?: Maybe<Scalars['String']['output']>;
  job?: Maybe<Job>;
  jobEvents: Array<JobEvent>;
  jobRef?: Maybe<Scalars['Int']['output']>;
  nonDoc?: Maybe<Scalars['Int']['output']>;
  pickupStop?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  reference: Scalars['ID']['output'];
  type?: Maybe<Scalars['Int']['output']>;
  unitCartons?: Maybe<Scalars['Float']['output']>;
  unitCube?: Maybe<Scalars['Float']['output']>;
  unitDepth?: Maybe<Scalars['Float']['output']>;
  unitHeight?: Maybe<Scalars['Float']['output']>;
  unitValue?: Maybe<Scalars['Float']['output']>;
  unitWeight?: Maybe<Scalars['Float']['output']>;
  unitWidth?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};


export type GoodGoodsFlagsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type GoodsFlag = {
  __typename?: 'GoodsFlag';
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['String']['output']>;
  goodsType?: Maybe<Scalars['Float']['output']>;
  reference: Scalars['ID']['output'];
  sortOrder?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type HealthCheck = {
  __typename?: 'HealthCheck';
  /** Whether a minimal access query against the database succeeded */
  databaseOk: Scalars['Boolean']['output'];
  /** SYSDATE as reported by the database, or null when unreachable. A wall clock reading with no timezone attached; the database server is not necessarily in the same zone as the caller. */
  databaseTime?: Maybe<Scalars['String']['output']>;
};

export type IntApp = {
  __typename?: 'IntApp';
  appName?: Maybe<Scalars['String']['output']>;
  intAppSettings: Array<IntAppSetting>;
  notificationEnabled?: Maybe<Scalars['String']['output']>;
  parentRef?: Maybe<Scalars['Int']['output']>;
  platformRef?: Maybe<Scalars['Int']['output']>;
  reference: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
};

export type IntAppSetting = {
  __typename?: 'IntAppSetting';
  appRef?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  intApp?: Maybe<IntApp>;
  platformRef?: Maybe<Scalars['Int']['output']>;
  reference: Scalars['ID']['output'];
  setting?: Maybe<Scalars['String']['output']>;
  settingType?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  validMins?: Maybe<Scalars['Int']['output']>;
};

export type IntFavourite = {
  __typename?: 'IntFavourite';
  address?: Maybe<Address>;
  addressDropType?: Maybe<Scalars['String']['output']>;
  addressRef?: Maybe<Scalars['Int']['output']>;
  contactRef?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  job?: Maybe<Job>;
  jobRef?: Maybe<Scalars['Int']['output']>;
  reference: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
};

export type IntJobFlag = {
  __typename?: 'IntJobFlag';
  accountRef?: Maybe<Scalars['String']['output']>;
  appRef?: Maybe<Scalars['Int']['output']>;
  contactRef?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Int']['output']>;
  flagRef?: Maybe<Scalars['Int']['output']>;
  goodsType?: Maybe<Scalars['Int']['output']>;
  reference: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
};

export type IntPlatform = {
  __typename?: 'IntPlatform';
  platformName?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  accountRef?: Maybe<Scalars['String']['output']>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  address4?: Maybe<Scalars['String']['output']>;
  cancelledDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  cntactCardRef?: Maybe<Scalars['Float']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  credit?: Maybe<Scalars['Float']['output']>;
  currencyNet?: Maybe<Scalars['Float']['output']>;
  currencyRef?: Maybe<Scalars['Float']['output']>;
  currencyTotal?: Maybe<Scalars['Float']['output']>;
  currencyVat?: Maybe<Scalars['Float']['output']>;
  ediBatch?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  exportBatch?: Maybe<Scalars['Float']['output']>;
  fao?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  generatedBatch?: Maybe<Scalars['Float']['output']>;
  invSendType?: Maybe<Scalars['Float']['output']>;
  invoiceDets: Array<InvoiceDet>;
  invoiceNum?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  net?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<Scalars['Float']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  printedDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  provisional?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  sendErrorText?: Maybe<Scalars['String']['output']>;
  taxDate?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  termsDesc?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
  vat?: Maybe<Scalars['Float']['output']>;
  vatMethod?: Maybe<Scalars['String']['output']>;
  vatRounding?: Maybe<Scalars['Float']['output']>;
};


export type InvoiceInvoiceDetsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type InvoiceDet = {
  __typename?: 'InvoiceDet';
  accountRef?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  currencyNet?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hideCalc?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<Invoice>;
  invoiceAdjust?: Maybe<Scalars['String']['output']>;
  invoiceJobRef?: Maybe<Scalars['Float']['output']>;
  invoiceRef?: Maybe<Scalars['Float']['output']>;
  job?: Maybe<Job>;
  jobRef?: Maybe<Scalars['Float']['output']>;
  manualRate?: Maybe<Scalars['Float']['output']>;
  net?: Maybe<Scalars['Float']['output']>;
  nominalCode?: Maybe<Scalars['String']['output']>;
  origRateDetRef?: Maybe<Scalars['Float']['output']>;
  pickupDate?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rateDetRef?: Maybe<Scalars['Float']['output']>;
  ratePerUnit?: Maybe<Scalars['Float']['output']>;
  reference: Scalars['ID']['output'];
  salesCurrenyRateRef?: Maybe<Scalars['Float']['output']>;
  sortOrder?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  vatCode?: Maybe<Scalars['String']['output']>;
};

export type Job = {
  __typename?: 'Job';
  account: Account;
  accountDept?: Maybe<Scalars['String']['output']>;
  accountDeptRef?: Maybe<Scalars['Int']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  accountRef?: Maybe<Scalars['String']['output']>;
  agentJobCode?: Maybe<Scalars['String']['output']>;
  agentLocationCurrent?: Maybe<LocationCurrent>;
  agentRef?: Maybe<Scalars['Int']['output']>;
  agentVehicleReg?: Maybe<Scalars['String']['output']>;
  allocatedLocationCurrent?: Maybe<LocationCurrent>;
  arriveBy: Scalars['Boolean']['output'];
  bankHol?: Maybe<Scalars['String']['output']>;
  baseLegDistance?: Maybe<Scalars['Float']['output']>;
  bookerEmail?: Maybe<Scalars['String']['output']>;
  bookerFax?: Maybe<Scalars['String']['output']>;
  bookerMobile?: Maybe<Scalars['String']['output']>;
  bookerName?: Maybe<Scalars['String']['output']>;
  bookerRef?: Maybe<Scalars['Int']['output']>;
  bookerTelephone?: Maybe<Scalars['String']['output']>;
  bookingControlId?: Maybe<Scalars['Int']['output']>;
  cancelNotes?: Maybe<Scalars['String']['output']>;
  cancelOnArrival?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  chargeFailReason?: Maybe<Scalars['String']['output']>;
  chargedAmount?: Maybe<Scalars['Float']['output']>;
  chargedAmountVat?: Maybe<Scalars['Float']['output']>;
  chargedDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  complStatus?: Maybe<Scalars['Int']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactFax?: Maybe<Scalars['String']['output']>;
  contactHasAccess: Scalars['Boolean']['output'];
  contactMobile?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  contactRef?: Maybe<Scalars['Int']['output']>;
  currencyChargedAmount?: Maybe<Scalars['Float']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  currencyEstCharge?: Maybe<Scalars['Float']['output']>;
  currencyEstChargeVat?: Maybe<Scalars['Float']['output']>;
  currencyEstPrice?: Maybe<Scalars['Float']['output']>;
  currencyEstPriceVat?: Maybe<Scalars['Float']['output']>;
  currencyPricedAmount?: Maybe<Scalars['Float']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  customerRaisedDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  customerVisibleDocuments?: Maybe<Array<Document>>;
  dateCancelled?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  dateCompleted?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  dateEntered?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  datePob?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  datePod?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  delay?: Maybe<Scalars['Int']['output']>;
  depotRef?: Maybe<Scalars['Int']['output']>;
  despInstructions?: Maybe<Scalars['String']['output']>;
  displayedJobFlags?: Maybe<Array<Flag>>;
  distFail?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  distanceCharged?: Maybe<Scalars['Float']['output']>;
  distancePriced?: Maybe<Scalars['Float']['output']>;
  documents?: Maybe<Array<Document>>;
  driver?: Maybe<Driver>;
  driverCallsign?: Maybe<Scalars['String']['output']>;
  driverLocationCurrent?: Maybe<LocationCurrent>;
  driverRef?: Maybe<Scalars['String']['output']>;
  enteredBy?: Maybe<Scalars['String']['output']>;
  estCharge?: Maybe<Scalars['Float']['output']>;
  estChargeFailReason?: Maybe<Scalars['String']['output']>;
  estChargeVat?: Maybe<Scalars['Float']['output']>;
  estEtaDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  estEtaMins?: Maybe<Scalars['Int']['output']>;
  estJourneyTime?: Maybe<Scalars['Int']['output']>;
  estPrice?: Maybe<Scalars['Float']['output']>;
  estPriceFailReason?: Maybe<Scalars['String']['output']>;
  estPriceVat?: Maybe<Scalars['Float']['output']>;
  eta?: Maybe<Scalars['String']['output']>;
  expectedPodDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  extJobRef?: Maybe<Scalars['String']['output']>;
  extSourceId?: Maybe<Scalars['Int']['output']>;
  extStatus?: Maybe<Scalars['Int']['output']>;
  extraRefs: Array<AccountExtraRef>;
  fixCharge?: Maybe<Scalars['String']['output']>;
  fixed?: Maybe<Scalars['String']['output']>;
  fixedCharge?: Maybe<Scalars['Float']['output']>;
  fixedPrice?: Maybe<Scalars['Float']['output']>;
  flags: Array<Flag>;
  formattedEstPrice?: Maybe<Scalars['String']['output']>;
  formattedEstPriceTotal?: Maybe<Scalars['String']['output']>;
  formattedEstPriceVat?: Maybe<Scalars['String']['output']>;
  fromAddress?: Maybe<Scalars['String']['output']>;
  goodAvailableDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  goods: Array<Good>;
  goodsDespatchedDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  goodsExpectedDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  goodsQty?: Maybe<Scalars['Int']['output']>;
  goodsType?: Maybe<Scalars['Int']['output']>;
  holdReason?: Maybe<Scalars['String']['output']>;
  invoiceDets?: Maybe<Array<InvoiceDet>>;
  invoiced?: Maybe<Scalars['String']['output']>;
  isJobContact: Scalars['Boolean']['output'];
  jobAgent?: Maybe<JobAgent>;
  jobCancels?: Maybe<Array<JobCancel>>;
  jobCards?: Maybe<Array<JobCard>>;
  jobCo2?: Maybe<Scalars['Int']['output']>;
  jobEvents: Array<JobEvent>;
  jobExtraRefs: Array<JobExtraRef>;
  jobExtras?: Maybe<Array<JobExtra>>;
  jobFlags?: Maybe<Scalars['String']['output']>;
  jobInvAddRef?: Maybe<Scalars['Int']['output']>;
  jobInvoiceNote?: Maybe<Scalars['String']['output']>;
  jobQuotes?: Maybe<Array<JobQuote>>;
  jobTime?: Maybe<Scalars['Float']['output']>;
  journeyTimeJourneys?: Maybe<Scalars['Int']['output']>;
  journeyTimeLevel?: Maybe<Scalars['Int']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  linkRef?: Maybe<Scalars['Int']['output']>;
  manualCharge?: Maybe<Scalars['String']['output']>;
  manualPrice?: Maybe<Scalars['String']['output']>;
  mobileDataDest?: Maybe<Scalars['String']['output']>;
  mobileDataId?: Maybe<Scalars['Int']['output']>;
  mobileDataParties?: Maybe<Scalars['Int']['output']>;
  mobileDataStatus?: Maybe<Scalars['Int']['output']>;
  mobileDataText?: Maybe<Scalars['String']['output']>;
  mop?: Maybe<Scalars['String']['output']>;
  normalisedEstPrice?: Maybe<Scalars['Float']['output']>;
  normalisedEstPriceTotal?: Maybe<Scalars['Float']['output']>;
  normalisedEstPriceVat?: Maybe<Scalars['Float']['output']>;
  noteFlag?: Maybe<Scalars['String']['output']>;
  numExtraDrivers?: Maybe<Scalars['Int']['output']>;
  numExtraRefs?: Maybe<Scalars['Int']['output']>;
  numStops?: Maybe<Scalars['Int']['output']>;
  /** Null when the FLIGHTDETAILS component is not installed. */
  oagFlightJob?: Maybe<OagFlightJob>;
  origJobQuoteRef?: Maybe<Scalars['Int']['output']>;
  otherRef?: Maybe<Scalars['String']['output']>;
  outOfHours?: Maybe<Scalars['String']['output']>;
  overrideDepot?: Maybe<Scalars['String']['output']>;
  overridePlanGroup?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<Scalars['Int']['output']>;
  pendingStatus?: Maybe<Scalars['Int']['output']>;
  pickupDate?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  pickupDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  pickupTime?: Maybe<Scalars['OurTimeResolver']['output']>;
  pickupTzOffset?: Maybe<Scalars['Int']['output']>;
  planGoods?: Maybe<Scalars['String']['output']>;
  planJourney?: Maybe<Scalars['String']['output']>;
  planningGroup?: Maybe<Scalars['String']['output']>;
  podRequired?: Maybe<Scalars['String']['output']>;
  prebook?: Maybe<Scalars['String']['output']>;
  priceFailReason?: Maybe<Scalars['String']['output']>;
  priceGroup?: Maybe<Scalars['String']['output']>;
  priceType?: Maybe<Scalars['Int']['output']>;
  pricedAmount?: Maybe<Scalars['Float']['output']>;
  pricedAmountVat?: Maybe<Scalars['Float']['output']>;
  pricedDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  priorityLevel?: Maybe<Scalars['Int']['output']>;
  proposedDriverCallsign?: Maybe<Scalars['String']['output']>;
  proposedDriverRef?: Maybe<Scalars['String']['output']>;
  purchCurrencyRateRef?: Maybe<Scalars['Int']['output']>;
  purchased?: Maybe<Scalars['String']['output']>;
  quoted?: Maybe<Scalars['String']['output']>;
  quotedSupp?: Maybe<Scalars['Int']['output']>;
  reference: Scalars['ID']['output'];
  repeatPickupDate?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  repeatRef?: Maybe<Scalars['Int']['output']>;
  repeatType?: Maybe<Scalars['Int']['output']>;
  resourcePlot?: Maybe<ResourcePlot>;
  rewardLogs?: Maybe<Array<RewardLog>>;
  salesCurrencyRateRef?: Maybe<Scalars['Int']['output']>;
  softAgentRef?: Maybe<Scalars['Int']['output']>;
  softDriver?: Maybe<Scalars['String']['output']>;
  softDriverCallsign?: Maybe<Scalars['String']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusFlags?: Maybe<Scalars['String']['output']>;
  statusText?: Maybe<Scalars['String']['output']>;
  stops: Array<Stop>;
  tariff?: Maybe<Scalars['String']['output']>;
  tariffDetail?: Maybe<Tariff>;
  tariffRef?: Maybe<Scalars['Int']['output']>;
  timeCharged?: Maybe<Scalars['Float']['output']>;
  timePriced?: Maybe<Scalars['Float']['output']>;
  toAddress?: Maybe<Scalars['String']['output']>;
  tracking: Array<VehicleMove>;
  tripPosn?: Maybe<Scalars['Int']['output']>;
  tripRef?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
  vehicle?: Maybe<Vehicle>;
  vehicleLocationCurrent?: Maybe<LocationCurrent>;
  vehicleRef?: Maybe<Scalars['String']['output']>;
  vouchers?: Maybe<Array<JobVoucher>>;
  waitReturn?: Maybe<Scalars['String']['output']>;
  webInstructions?: Maybe<Scalars['String']['output']>;
  webInstructionsMaxLength: Scalars['Int']['output'];
  webTariff?: Maybe<WebTariff>;
};


export type JobContactHasAccessArgs = {
  contactRef: Scalars['Int']['input'];
};


export type JobCustomerVisibleDocumentsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobDisplayedJobFlagsArgs = {
  accountRef: Scalars['String']['input'];
  appName: Scalars['String']['input'];
  contactRef: Scalars['Int']['input'];
  platformName: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobDocumentsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobDriverArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobExtraRefsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobFlagsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobGoodsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobInvoiceDetsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobIsJobContactArgs = {
  contactRef: Scalars['Int']['input'];
};


export type JobJobAgentArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobJobCancelsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobJobCardsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobJobEventsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobJobExtraRefsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobJobExtrasArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobJobQuotesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobOagFlightJobArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobResourcePlotArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobRewardLogsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobStopsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobTrackingArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobVehicleArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type JobAgent = {
  __typename?: 'JobAgent';
  callsign?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  driverOLicense?: Maybe<Scalars['String']['output']>;
  driverPhone?: Maybe<Scalars['String']['output']>;
  job?: Maybe<Job>;
  jobRef?: Maybe<Scalars['Int']['output']>;
  photo?: Maybe<Picture>;
  reference: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
  vehicleColour?: Maybe<Scalars['String']['output']>;
  vehicleDesc?: Maybe<Scalars['String']['output']>;
  vehicleOLicense?: Maybe<Scalars['String']['output']>;
  vehicleReg?: Maybe<Scalars['String']['output']>;
  vehicleType?: Maybe<Scalars['String']['output']>;
};


export type JobAgentJobArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobAgentPhotoArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type JobCancel = {
  __typename?: 'JobCancel';
  cancelDt?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  job?: Maybe<Job>;
  jobRef?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  userCode?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type JobCard = {
  __typename?: 'JobCard';
  amount?: Maybe<Scalars['Float']['output']>;
  authorisation?: Maybe<Scalars['String']['output']>;
  contactCard?: Maybe<ContactCard>;
  contactCardRef?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencyRef?: Maybe<Scalars['Float']['output']>;
  job?: Maybe<Job>;
  jobRef?: Maybe<Scalars['Float']['output']>;
  numTransactions?: Maybe<Scalars['Float']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['Float']['output']>;
  reference: Scalars['ID']['output'];
  status?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type JobEvent = {
  __typename?: 'JobEvent';
  event?: Maybe<Event>;
  eventDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  eventGenDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  eventRef?: Maybe<Scalars['Int']['output']>;
  eventText?: Maybe<Scalars['String']['output']>;
  good?: Maybe<Good>;
  goodsRef?: Maybe<Scalars['Int']['output']>;
  job?: Maybe<Job>;
  jobRef?: Maybe<Scalars['Int']['output']>;
  reference: Scalars['ID']['output'];
  stop?: Maybe<Stop>;
  stopRef?: Maybe<Scalars['Int']['output']>;
  userCode?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};


export type JobEventEventArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobEventGoodArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobEventJobArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobEventStopArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type JobExtra = {
  __typename?: 'JobExtra';
  code?: Maybe<Scalars['String']['output']>;
  defaultExtra?: Maybe<DefaultExtra>;
  defaultRef?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  job?: Maybe<Job>;
  jobRef?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  reference: Scalars['ID']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  warnCharging?: Maybe<Scalars['String']['output']>;
  warnPricing?: Maybe<Scalars['String']['output']>;
};

export type JobExtraRef = {
  __typename?: 'JobExtraRef';
  accountDeptRef?: Maybe<Scalars['Int']['output']>;
  accountExtraRefRef?: Maybe<Scalars['Int']['output']>;
  job?: Maybe<Job>;
  jobRef?: Maybe<Scalars['Int']['output']>;
  reference: Scalars['ID']['output'];
  referenceValue?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type JobQuote = {
  __typename?: 'JobQuote';
  accountDept?: Maybe<Scalars['String']['output']>;
  accountDeptRef?: Maybe<Scalars['Float']['output']>;
  accountRef?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactRef?: Maybe<Scalars['Float']['output']>;
  depotRef?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  despInstructions?: Maybe<Scalars['String']['output']>;
  fixCharge?: Maybe<Scalars['String']['output']>;
  fixed?: Maybe<Scalars['String']['output']>;
  fixedCharge?: Maybe<Scalars['Float']['output']>;
  fixedPrice?: Maybe<Scalars['Float']['output']>;
  flags: Array<Flag>;
  fromAddress?: Maybe<Scalars['String']['output']>;
  job?: Maybe<Job>;
  jobFlags?: Maybe<Scalars['String']['output']>;
  jobQuoteExtraRefs: Array<JobQuoteExtraRef>;
  jobQuoteStops: Array<JobQuoteStop>;
  jobRef?: Maybe<Scalars['Float']['output']>;
  mop?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  otherRef?: Maybe<Scalars['String']['output']>;
  pickupDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  prebook?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  priorityLevel?: Maybe<Scalars['Float']['output']>;
  purchCurrencyRateRef?: Maybe<Scalars['Float']['output']>;
  quotedDistance?: Maybe<Scalars['Float']['output']>;
  quotedDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  quotedNet?: Maybe<Scalars['Float']['output']>;
  quotedTime?: Maybe<Scalars['Float']['output']>;
  quotedTotal?: Maybe<Scalars['Float']['output']>;
  quotedVat?: Maybe<Scalars['Float']['output']>;
  reference: Scalars['ID']['output'];
  relatedRecord?: Maybe<Scalars['String']['output']>;
  relatedTable?: Maybe<Scalars['String']['output']>;
  salesCurrencyRateRef?: Maybe<Scalars['Float']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  suppQuotedDistance?: Maybe<Scalars['Float']['output']>;
  suppQuotedDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  suppQuotedNet?: Maybe<Scalars['Float']['output']>;
  suppQuotedTime?: Maybe<Scalars['Float']['output']>;
  suppQuotedTotal?: Maybe<Scalars['Float']['output']>;
  suppQuotedVat?: Maybe<Scalars['Float']['output']>;
  tariff?: Maybe<Scalars['String']['output']>;
  tariffRef?: Maybe<Scalars['Float']['output']>;
  toAddress?: Maybe<Scalars['String']['output']>;
  userRef?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
  waitReturn?: Maybe<Scalars['String']['output']>;
  webInstructions?: Maybe<Scalars['String']['output']>;
  webInstructionsMaxLength: Scalars['Int']['output'];
};


export type JobQuoteFlagsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobQuoteJobQuoteExtraRefsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobQuoteJobQuoteStopsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type JobQuoteExtraRef = {
  __typename?: 'JobQuoteExtraRef';
  accountdeptRef?: Maybe<Scalars['Float']['output']>;
  accountextrarefRef?: Maybe<Scalars['Float']['output']>;
  jobQuote?: Maybe<JobQuote>;
  jobquoteRef?: Maybe<Scalars['Float']['output']>;
  reference: Scalars['ID']['output'];
  referenceValue?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type JobQuoteRewardLog = {
  __typename?: 'JobQuoteRewardLog';
  datetimeUsed?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  oldTariffPrice?: Maybe<Scalars['Float']['output']>;
  quoteRef?: Maybe<Scalars['Int']['output']>;
  reference: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
  voucherRef?: Maybe<Scalars['String']['output']>;
};

export type JobQuoteStop = {
  __typename?: 'JobQuoteStop';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  address4?: Maybe<Scalars['String']['output']>;
  addressCode?: Maybe<Scalars['String']['output']>;
  addressName?: Maybe<Scalars['String']['output']>;
  addressRef?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  dropOrder?: Maybe<Scalars['Float']['output']>;
  gridX?: Maybe<Scalars['Float']['output']>;
  gridY?: Maybe<Scalars['Float']['output']>;
  jobQuote?: Maybe<JobQuote>;
  jobQuoteRef?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  stopTime?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type JobVoucher = {
  __typename?: 'JobVoucher';
  voucherCode: Scalars['String']['output'];
  voucherRef: Scalars['Float']['output'];
};

export type LocationCurrent = {
  __typename?: 'LocationCurrent';
  agentRef?: Maybe<Scalars['Int']['output']>;
  driverRef?: Maybe<Scalars['String']['output']>;
  headingDegrees?: Maybe<Scalars['Int']['output']>;
  jobRef?: Maybe<Scalars['Int']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  locationDateTimeOffsetMins?: Maybe<Scalars['Int']['output']>;
  locationDateTimeUtc?: Maybe<Scalars['OurDateTimeResolver']['output']>;
  locationDescription?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  reference: Scalars['ID']['output'];
  revision?: Maybe<Scalars['Int']['output']>;
  sourceId?: Maybe<Scalars['Int']['output']>;
  speedMph?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
  vehicleRef?: Maybe<Scalars['String']['output']>;
};

export type OagFlightJob = {
  __typename?: 'OagFlightJob';
  actualArrivalDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  actualDepartureDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  addressRef?: Maybe<Scalars['Int']['output']>;
  arrival?: Maybe<Scalars['String']['output']>;
  arriveAirportCode?: Maybe<Scalars['String']['output']>;
  calcEta?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  carrierCode?: Maybe<Scalars['String']['output']>;
  createdDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  dataRefreshedDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  departAirportCode?: Maybe<Scalars['String']['output']>;
  divertAirportCode?: Maybe<Scalars['String']['output']>;
  estimatedArrivalDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  estimatedDepartureDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  estimatedTouchDownDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  flightCode?: Maybe<Scalars['String']['output']>;
  flightDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  flightNo?: Maybe<Scalars['String']['output']>;
  flightRef?: Maybe<Scalars['Int']['output']>;
  fromToCity?: Maybe<Scalars['String']['output']>;
  holdOff?: Maybe<Scalars['Int']['output']>;
  icaoCode?: Maybe<Scalars['String']['output']>;
  job?: Maybe<Job>;
  jobRef?: Maybe<Scalars['Int']['output']>;
  overridePickup?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  scheduledArrivalDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  scheduledDepartureDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  statusEta?: Maybe<Scalars['String']['output']>;
  statusShort?: Maybe<Scalars['String']['output']>;
  statusText?: Maybe<Scalars['String']['output']>;
  stopRef?: Maybe<Scalars['Int']['output']>;
  terminal?: Maybe<Scalars['String']['output']>;
  trackFlight?: Maybe<Scalars['String']['output']>;
  updatedDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  uuid: Scalars['String']['output'];
};


export type OagFlightJobJobArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type Parameter = {
  __typename?: 'Parameter';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  setting?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type Picture = {
  __typename?: 'Picture';
  dataUri?: Maybe<Scalars['String']['output']>;
  picBinary?: Maybe<Scalars['Image']['output']>;
  picFormat?: Maybe<Scalars['String']['output']>;
  picHeight?: Maybe<Scalars['Int']['output']>;
  picName?: Maybe<Scalars['String']['output']>;
  picWidth?: Maybe<Scalars['Int']['output']>;
  reference: Scalars['ID']['output'];
  relatedRecord?: Maybe<Scalars['String']['output']>;
  relatedTable?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  account: Account;
  accountdept: AccountDept;
  accountdepts: Array<AccountDept>;
  accountextraref: AccountExtraRef;
  accountextrarefs: Array<AccountExtraRef>;
  accounts: Array<Account>;
  accountwebsetting: AccountWebSetting;
  accountwebsettings: Array<AccountWebSetting>;
  address: Address;
  addressByCode?: Maybe<Address>;
  addresses: Array<Address>;
  addresstype: AddressType;
  addresstypes: Array<AddressType>;
  availableCountries: Array<Country>;
  availableCountriesOverride: Array<CountriesOverride>;
  contact: Contact;
  contactcard: ContactCard;
  contactcards: Array<ContactCard>;
  contactdetail: ContactDetail;
  contactdetails: Array<ContactDetail>;
  contactreflink: ContactRefLink;
  contactreflinks: Array<ContactRefLink>;
  contacts: Array<Contact>;
  countries: Array<Country>;
  countriesoverride: CountriesOverride;
  countriesoverrides: Array<CountriesOverride>;
  country: Country;
  currencies: Array<Currency>;
  currency: Currency;
  currencyrate: CurrencyRate;
  currencyrates: Array<CurrencyRate>;
  defaultAddresses: AddressDefaults;
  defaultextra: DefaultExtra;
  defaultextras: Array<DefaultExtra>;
  delay: Delay;
  delays: Array<Delay>;
  document: Document;
  documentobj: DocumentObj;
  documentobjs: Array<DocumentObj>;
  documents: Array<Document>;
  documenttype: DocumentType;
  documenttypes: Array<DocumentType>;
  driver: Driver;
  drivers: Array<Driver>;
  earliestDelay?: Maybe<Scalars['Float']['output']>;
  event: Event;
  events: Array<Event>;
  flag: Flag;
  flags: Array<Flag>;
  flagsById?: Maybe<Array<Flag>>;
  goflowheader: GoFlowHeader;
  goflowheaders: Array<GoFlowHeader>;
  good: Good;
  goods: Array<Good>;
  goodsFlagsByGoodsTypes?: Maybe<Array<GoodsFlag>>;
  goodsFlagsByRef?: Maybe<Array<GoodsFlag>>;
  goodsflag: GoodsFlag;
  goodsflags: Array<GoodsFlag>;
  healthCheck: HealthCheck;
  intJobFlagsByAccountAndContact?: Maybe<Array<IntJobFlag>>;
  intapp: IntApp;
  intapps: Array<IntApp>;
  intappsetting: IntAppSetting;
  intappsettings: Array<IntAppSetting>;
  intfavourite: IntFavourite;
  intfavourites: Array<IntFavourite>;
  intjobflag: IntJobFlag;
  intjobflags: Array<IntJobFlag>;
  intplatform: IntPlatform;
  intplatforms: Array<IntPlatform>;
  invoice: Invoice;
  invoicedet: InvoiceDet;
  invoicedets: Array<InvoiceDet>;
  invoices: Array<Invoice>;
  job: Job;
  jobFromTrackingLink?: Maybe<Job>;
  jobagent: JobAgent;
  jobagents: Array<JobAgent>;
  jobcancel: JobCancel;
  jobcancels: Array<JobCancel>;
  jobcard: JobCard;
  jobcards: Array<JobCard>;
  jobevent: JobEvent;
  jobevents: Array<JobEvent>;
  jobextra: JobExtra;
  jobextraref: JobExtraRef;
  jobextrarefs: Array<JobExtraRef>;
  jobextras: Array<JobExtra>;
  jobquote: JobQuote;
  jobquoteextraref: JobQuoteExtraRef;
  jobquoteextrarefs: Array<JobQuoteExtraRef>;
  jobquoterewardlog: JobQuoteRewardLog;
  jobquoterewardlogs: Array<JobQuoteRewardLog>;
  jobquotes: Array<JobQuote>;
  jobquotestop: JobQuoteStop;
  jobquotestops: Array<JobQuoteStop>;
  jobs: Array<Job>;
  locationcurrent: LocationCurrent;
  locationcurrents: Array<LocationCurrent>;
  oagflightjob: OagFlightJob;
  /** Empty when the FLIGHTDETAILS component is not installed. */
  oagflightjobs: Array<OagFlightJob>;
  parameter: Parameter;
  parameters: Array<Parameter>;
  picture: Picture;
  pictures: Array<Picture>;
  /** Whether any enabled booking template is offered to guests, so a quote can be made without an account */
  quickQuoteAvailable: Scalars['Boolean']['output'];
  resourceplot: ResourcePlot;
  resourceplots: Array<ResourcePlot>;
  reward: Reward;
  rewardRefByCode?: Maybe<Scalars['Float']['output']>;
  rewardlog: RewardLog;
  rewardlogs: Array<RewardLog>;
  rewards: Array<Reward>;
  setting: Setting;
  settings: Array<Setting>;
  stop: Stop;
  stops: Array<Stop>;
  tariff: Tariff;
  tariffs: Array<Tariff>;
  universalAddresses: Array<AddressWithType>;
  vehicle: Vehicle;
  vehiclemove: VehicleMove;
  vehiclemoves: Array<VehicleMove>;
  vehicles: Array<Vehicle>;
  webaccess: WebAccess;
  webaccesses: Array<WebAccess>;
  webreport: WebReport;
  webreports: Array<WebReport>;
  webtariff: WebTariff;
  webtariffs: Array<WebTariff>;
};


export type QueryAccountArgs = {
  reference: Scalars['String']['input'];
};


export type QueryAccountdeptArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryAccountdeptsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAccountextrarefArgs = {
  accountRef: Scalars['String']['input'];
  reference: Scalars['Int']['input'];
};


export type QueryAccountextrarefsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAccountsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAccountwebsettingArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryAccountwebsettingsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAddressArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryAddressByCodeArgs = {
  accountRef?: InputMaybe<Scalars['String']['input']>;
  addressCode: Scalars['String']['input'];
  contactRef?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAddressesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAddresstypeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAddresstypesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAvailableCountriesOverrideArgs = {
  accountRef: Scalars['String']['input'];
  contactRef?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContactArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryContactcardArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryContactcardsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContactdetailArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryContactdetailsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContactreflinkArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryContactreflinksArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContactsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCountriesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCountriesoverrideArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryCountriesoverridesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCountryArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryCurrenciesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCurrencyArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryCurrencyrateArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryCurrencyratesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDefaultAddressesArgs = {
  accountRef?: InputMaybe<Scalars['String']['input']>;
  contactRef?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDefaultextraArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryDefaultextrasArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDelayArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryDelaysArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDocumentArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryDocumentobjArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryDocumentobjsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDocumentsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDocumenttypeArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryDocumenttypesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDriverArgs = {
  reference: Scalars['String']['input'];
};


export type QueryDriversArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEventArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryEventsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFlagArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryFlagsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFlagsByIdArgs = {
  flagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryGoflowheaderArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryGoflowheadersArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGoodArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryGoodsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGoodsFlagsByGoodsTypesArgs = {
  goodsTypes?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryGoodsFlagsByRefArgs = {
  flagRefs?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryGoodsflagArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryGoodsflagsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIntJobFlagsByAccountAndContactArgs = {
  accountRef: Scalars['String']['input'];
  contactRef: Scalars['Int']['input'];
};


export type QueryIntappArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryIntappsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIntappsettingArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryIntappsettingsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIntfavouriteArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryIntfavouritesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIntjobflagArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryIntjobflagsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIntplatformArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryIntplatformsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInvoiceArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryInvoicedetArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryInvoicedetsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInvoicesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryJobFromTrackingLinkArgs = {
  trackingLink?: InputMaybe<Scalars['String']['input']>;
};


export type QueryJobagentArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryJobagentsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobcancelArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryJobcancelsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobcardArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryJobcardsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobeventArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryJobeventsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobextraArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryJobextrarefArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryJobextrarefsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobextrasArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobquoteArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryJobquoteextrarefArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryJobquoteextrarefsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobquoterewardlogArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryJobquoterewardlogsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobquotesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobquotestopArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryJobquotestopsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLocationcurrentArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryLocationcurrentsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOagflightjobArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryOagflightjobsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryParameterArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryParametersArgs = {
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPictureArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryPicturesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryResourceplotArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryResourceplotsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRewardArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryRewardRefByCodeArgs = {
  voucherCode: Scalars['String']['input'];
};


export type QueryRewardlogArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryRewardlogsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRewardsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySettingArgs = {
  reference: Scalars['Int']['input'];
};


export type QuerySettingsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStopArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryStopsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTariffArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryTariffsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUniversalAddressesArgs = {
  accountRef?: InputMaybe<Scalars['String']['input']>;
  contactRef?: InputMaybe<Scalars['Int']['input']>;
  partial?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryVehicleArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryVehiclemoveArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryVehiclemovesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVehiclesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWebaccessArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryWebaccessesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWebreportArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryWebreportsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWebtariffArgs = {
  reference: Scalars['Int']['input'];
};


export type QueryWebtariffsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ResourcePlot = {
  __typename?: 'ResourcePlot';
  currentJobRef?: Maybe<Scalars['Float']['output']>;
  currentJobStats?: Maybe<Scalars['String']['output']>;
  currentPostDistrict?: Maybe<Scalars['String']['output']>;
  driverRef: Scalars['String']['output'];
  instructionRef?: Maybe<Scalars['Float']['output']>;
  job?: Maybe<Job>;
  jobStatsHistory?: Maybe<Scalars['String']['output']>;
  lastAvailableDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  manualPlot?: Maybe<Scalars['Float']['output']>;
  mobileStatus?: Maybe<Scalars['String']['output']>;
  mobileStatusDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  plotChangedDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  plotRef?: Maybe<Scalars['Float']['output']>;
  reference: Scalars['ID']['output'];
  revision?: Maybe<Scalars['Float']['output']>;
  shiftRef?: Maybe<Scalars['Float']['output']>;
  statusFlags?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type Reward = {
  __typename?: 'Reward';
  accountRef?: Maybe<Scalars['String']['output']>;
  allowedUses?: Maybe<Scalars['Int']['output']>;
  autoDisabled?: Maybe<Scalars['String']['output']>;
  autoGenerateRule?: Maybe<Scalars['Int']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactRef?: Maybe<Scalars['Int']['output']>;
  createdDate?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  disabled?: Maybe<Scalars['String']['output']>;
  expiresDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  inConjunction?: Maybe<Scalars['String']['output']>;
  platformRef?: Maybe<Scalars['Int']['output']>;
  reference: Scalars['ID']['output'];
  rewardLogs?: Maybe<Array<RewardLog>>;
  tariffRefFrom?: Maybe<Scalars['Int']['output']>;
  tariffRefTo?: Maybe<Scalars['Int']['output']>;
  threshold?: Maybe<Scalars['Int']['output']>;
  timesUsed?: Maybe<Scalars['Int']['output']>;
  typeUsed?: Maybe<Scalars['Int']['output']>;
  usableBy?: Maybe<Scalars['Int']['output']>;
  usesFlag?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
  voucherCode?: Maybe<Scalars['String']['output']>;
  voucherType?: Maybe<Scalars['Int']['output']>;
};


export type RewardRewardLogsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type RewardLog = {
  __typename?: 'RewardLog';
  datetimeUsed?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  job?: Maybe<Job>;
  jobRef?: Maybe<Scalars['Int']['output']>;
  oldTariffPrice?: Maybe<Scalars['Float']['output']>;
  reference: Scalars['ID']['output'];
  reward?: Maybe<Reward>;
  uuid: Scalars['String']['output'];
  voucherRef?: Maybe<Scalars['String']['output']>;
};

export type Setting = {
  __typename?: 'Setting';
  accountDeptDesc?: Maybe<Scalars['String']['output']>;
  allowAddressSave?: Maybe<Scalars['String']['output']>;
  allowPassengerSave?: Maybe<Scalars['String']['output']>;
  allowStopContactNotify?: Maybe<Scalars['String']['output']>;
  allowedGoodsTypes?: Maybe<Scalars['String']['output']>;
  applicationName?: Maybe<Scalars['String']['output']>;
  authClientId?: Maybe<Scalars['String']['output']>;
  authClientSecret?: Maybe<Scalars['String']['output']>;
  authUrl?: Maybe<Scalars['String']['output']>;
  autoCalcWtDesktop?: Maybe<Scalars['Float']['output']>;
  autoCalcWtFirstStop?: Maybe<Scalars['Float']['output']>;
  autoCalcWtMobileData?: Maybe<Scalars['Float']['output']>;
  bookingObjects?: Maybe<Scalars['String']['output']>;
  calcStopReqsAsap?: Maybe<Scalars['Float']['output']>;
  calendar?: Maybe<Scalars['String']['output']>;
  completeType?: Maybe<Scalars['Float']['output']>;
  compulsoryDriverVehicle?: Maybe<Scalars['String']['output']>;
  compulsoryGoods?: Maybe<Scalars['String']['output']>;
  contactFields?: Maybe<Scalars['String']['output']>;
  copyBookerToContact?: Maybe<Scalars['String']['output']>;
  copyContactToBooker?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  currencyRef?: Maybe<Scalars['Float']['output']>;
  defaultAccountVatMethod?: Maybe<Scalars['String']['output']>;
  defaultCo2Emissions?: Maybe<Scalars['Float']['output']>;
  defaultCountryCode?: Maybe<Scalars['String']['output']>;
  defaultGoodsType?: Maybe<Scalars['Float']['output']>;
  defaultStopCountryToAcc?: Maybe<Scalars['Float']['output']>;
  defaultSupplierVatMethod?: Maybe<Scalars['String']['output']>;
  descRef?: Maybe<Scalars['String']['output']>;
  dftAutoActMsgSent?: Maybe<Scalars['String']['output']>;
  dftAutoActMsgView?: Maybe<Scalars['String']['output']>;
  dftInvCompletedOnly?: Maybe<Scalars['String']['output']>;
  dftInvHoldLinkedJobs?: Maybe<Scalars['String']['output']>;
  dftJobDepotCalc?: Maybe<Scalars['Float']['output']>;
  dftPurchCompletedOnly?: Maybe<Scalars['String']['output']>;
  dftReinstateMsgRpd?: Maybe<Scalars['String']['output']>;
  dftUpdateCurrentJobRef?: Maybe<Scalars['Float']['output']>;
  distDesc?: Maybe<Scalars['String']['output']>;
  distDp?: Maybe<Scalars['Float']['output']>;
  distanceChargingMethod?: Maybe<Scalars['Float']['output']>;
  distanceDefaultMethod?: Maybe<Scalars['Float']['output']>;
  distanceJobMethod?: Maybe<Scalars['Float']['output']>;
  distancePricingMethod?: Maybe<Scalars['Float']['output']>;
  distanceRoundCharge?: Maybe<Scalars['Float']['output']>;
  distanceRoundPrice?: Maybe<Scalars['Float']['output']>;
  distanceTrackingMethod?: Maybe<Scalars['Float']['output']>;
  doNotUseAccountContact?: Maybe<Scalars['String']['output']>;
  driverReqd?: Maybe<Scalars['String']['output']>;
  estChargeType?: Maybe<Scalars['Float']['output']>;
  estPriceType?: Maybe<Scalars['Float']['output']>;
  fullDropAdd?: Maybe<Scalars['String']['output']>;
  fullPickupAdd?: Maybe<Scalars['String']['output']>;
  goodsButtonName?: Maybe<Scalars['String']['output']>;
  goodsDesc?: Maybe<Scalars['String']['output']>;
  goodsInfo1Desc?: Maybe<Scalars['String']['output']>;
  goodsInfo2Desc?: Maybe<Scalars['String']['output']>;
  goodsInfo3Desc?: Maybe<Scalars['String']['output']>;
  invPerCompany?: Maybe<Scalars['String']['output']>;
  invoiceVatRounding?: Maybe<Scalars['Float']['output']>;
  jobVatRounding?: Maybe<Scalars['Float']['output']>;
  lastVersion?: Maybe<Scalars['String']['output']>;
  lookupChrs?: Maybe<Scalars['String']['output']>;
  minimumJobStops?: Maybe<Scalars['Float']['output']>;
  monitorClientId?: Maybe<Scalars['String']['output']>;
  monitorTableInserts?: Maybe<Scalars['String']['output']>;
  monitorUrl?: Maybe<Scalars['String']['output']>;
  otherRefDesc?: Maybe<Scalars['String']['output']>;
  planFieldDelim?: Maybe<Scalars['String']['output']>;
  planJourneyField1?: Maybe<Scalars['String']['output']>;
  planJourneyField2?: Maybe<Scalars['String']['output']>;
  planJourneyField3?: Maybe<Scalars['String']['output']>;
  planJourneyField4?: Maybe<Scalars['String']['output']>;
  planJourneyItems?: Maybe<Scalars['Float']['output']>;
  planStopDelim?: Maybe<Scalars['String']['output']>;
  pobReqd?: Maybe<Scalars['String']['output']>;
  podReqd?: Maybe<Scalars['String']['output']>;
  prefixAccount?: Maybe<Scalars['String']['output']>;
  prefixDriver?: Maybe<Scalars['String']['output']>;
  prefixVehicle?: Maybe<Scalars['String']['output']>;
  priceFailKnownLocns?: Maybe<Scalars['Float']['output']>;
  priceKnownLocns?: Maybe<Scalars['String']['output']>;
  purchPerCompany?: Maybe<Scalars['String']['output']>;
  qAddress?: Maybe<Scalars['String']['output']>;
  ratelineVatRounding?: Maybe<Scalars['Float']['output']>;
  reference: Scalars['ID']['output'];
  reportTagLine?: Maybe<Scalars['String']['output']>;
  showLaunchpad?: Maybe<Scalars['String']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
  timeDesc?: Maybe<Scalars['String']['output']>;
  timeDesc2?: Maybe<Scalars['String']['output']>;
  timeMultiply?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
  vatCode?: Maybe<Scalars['String']['output']>;
  vatCodeSupplier?: Maybe<Scalars['String']['output']>;
  vehicleReqd?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Stop = {
  __typename?: 'Stop';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  address4?: Maybe<Scalars['String']['output']>;
  addressCode?: Maybe<Scalars['String']['output']>;
  addressName?: Maybe<Scalars['String']['output']>;
  addressRef?: Maybe<Scalars['Int']['output']>;
  asDirected: Scalars['Boolean']['output'];
  asDirectedTime?: Maybe<Scalars['Float']['output']>;
  asDirectedTimeUnit?: Maybe<Scalars['String']['output']>;
  completedName?: Maybe<Scalars['String']['output']>;
  completedNotes?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactMobile?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactTelephone?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  dateCompleted?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  dpickupGoodsWeight?: Maybe<Scalars['Float']['output']>;
  dropGoodsCube?: Maybe<Scalars['Float']['output']>;
  dropGoodsQty?: Maybe<Scalars['Int']['output']>;
  dropGoodsValue?: Maybe<Scalars['Float']['output']>;
  dropGoodsWeight?: Maybe<Scalars['Float']['output']>;
  dropOrder?: Maybe<Scalars['Int']['output']>;
  dropType?: Maybe<Scalars['String']['output']>;
  estNextTravelMins?: Maybe<Scalars['Int']['output']>;
  gridX?: Maybe<Scalars['Float']['output']>;
  gridY?: Maybe<Scalars['Float']['output']>;
  job?: Maybe<Job>;
  jobEvents: Array<JobEvent>;
  jobRef?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pickupGoodsCube?: Maybe<Scalars['Float']['output']>;
  pickupGoodsQty?: Maybe<Scalars['Int']['output']>;
  pickupGoodsValue?: Maybe<Scalars['Float']['output']>;
  plannedArrivalDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  plotRef?: Maybe<Scalars['Int']['output']>;
  podImages: Array<Picture>;
  postcode?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  reqDtsManuallyEdited?: Maybe<Scalars['Int']['output']>;
  requiredFromDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  requiredFromTzOffset?: Maybe<Scalars['Int']['output']>;
  requiredToDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  requiredToTzOffset?: Maybe<Scalars['Int']['output']>;
  stopDistance?: Maybe<Scalars['Float']['output']>;
  stopTime?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
  zone?: Maybe<Scalars['String']['output']>;
};


export type StopPodImagesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type Tariff = {
  __typename?: 'Tariff';
  company?: Maybe<Scalars['String']['output']>;
  cutoffTime?: Maybe<Scalars['OurTimeResolver']['output']>;
  defaultGoodsType?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['String']['output']>;
  maxGoodsCarton?: Maybe<Scalars['Float']['output']>;
  maxGoodsDepth?: Maybe<Scalars['Float']['output']>;
  maxGoodsHeight?: Maybe<Scalars['Float']['output']>;
  maxGoodsQty?: Maybe<Scalars['Int']['output']>;
  maxGoodsWeight?: Maybe<Scalars['Float']['output']>;
  maxGoodsWidth?: Maybe<Scalars['Float']['output']>;
  planningGroup?: Maybe<Scalars['String']['output']>;
  priceGroup?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  tariff?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type Vehicle = {
  __typename?: 'Vehicle';
  agentRef?: Maybe<Scalars['Int']['output']>;
  agentVehicleRef?: Maybe<Scalars['String']['output']>;
  allocationCriteraRefs?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<Scalars['String']['output']>;
  chassisRef?: Maybe<Scalars['String']['output']>;
  co2Emissions?: Maybe<Scalars['Int']['output']>;
  dateAcquired?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  dateInspectionExpires?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  dateMotExpires?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  dateRegistered?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  dateRoadTaxExpires?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  dateSold?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  dvlcClass?: Maybe<Scalars['String']['output']>;
  engineCapacity?: Maybe<Scalars['Float']['output']>;
  engineRef?: Maybe<Scalars['String']['output']>;
  fleetGroup?: Maybe<Scalars['String']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  gridX?: Maybe<Scalars['Float']['output']>;
  gridY?: Maybe<Scalars['Float']['output']>;
  insuranceExpiresDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  keeperAddressRef?: Maybe<Scalars['Int']['output']>;
  lastMot?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  lastRecMileage?: Maybe<Scalars['Int']['output']>;
  lastRecMileageDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  lastService?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  lastServiceMileage?: Maybe<Scalars['Int']['output']>;
  locationDesc?: Maybe<Scalars['String']['output']>;
  locationDir?: Maybe<Scalars['Float']['output']>;
  locationDriverRef?: Maybe<Scalars['String']['output']>;
  locationDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  locationEvent?: Maybe<Scalars['Int']['output']>;
  locationEventParam?: Maybe<Scalars['String']['output']>;
  locationOdometer?: Maybe<Scalars['Int']['output']>;
  locationReq?: Maybe<Scalars['String']['output']>;
  locationReqText?: Maybe<Scalars['String']['output']>;
  locationRfidId?: Maybe<Scalars['String']['output']>;
  locationSource?: Maybe<Scalars['String']['output']>;
  locationSpeed?: Maybe<Scalars['Float']['output']>;
  locationStatus?: Maybe<Scalars['Int']['output']>;
  locationType?: Maybe<Scalars['Int']['output']>;
  manufYear?: Maybe<Scalars['Int']['output']>;
  maxGoods?: Maybe<Scalars['Int']['output']>;
  maxWeight?: Maybe<Scalars['Float']['output']>;
  mobileDataId?: Maybe<Scalars['Int']['output']>;
  mobileDataStatus?: Maybe<Scalars['Int']['output']>;
  mobileDataText?: Maybe<Scalars['String']['output']>;
  nextMot?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  nextService?: Maybe<Scalars['OurLocalDateResolver']['output']>;
  oLicense?: Maybe<Scalars['String']['output']>;
  ownershipType?: Maybe<Scalars['String']['output']>;
  planningGroup?: Maybe<Scalars['String']['output']>;
  radioCode?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  registration?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  roadTaxValidUntil?: Maybe<Scalars['String']['output']>;
  sizeClass?: Maybe<Scalars['String']['output']>;
  startSite?: Maybe<Scalars['String']['output']>;
  subGroup?: Maybe<Scalars['String']['output']>;
  telMobile?: Maybe<Scalars['String']['output']>;
  trackingId?: Maybe<Scalars['String']['output']>;
  typeClass?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  vehicleClass?: Maybe<Scalars['String']['output']>;
  vehicleColour?: Maybe<Scalars['String']['output']>;
  vehicleFlags?: Maybe<Scalars['String']['output']>;
  vehicleType?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type VehicleMove = {
  __typename?: 'VehicleMove';
  event?: Maybe<Scalars['Int']['output']>;
  eventParam?: Maybe<Scalars['String']['output']>;
  gridX?: Maybe<Scalars['Float']['output']>;
  gridY?: Maybe<Scalars['Float']['output']>;
  locationDateTimeUtc?: Maybe<Scalars['OurDateTimeResolver']['output']>;
  locationDesc?: Maybe<Scalars['String']['output']>;
  locationDir?: Maybe<Scalars['Float']['output']>;
  locationDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  locationSpeed?: Maybe<Scalars['Float']['output']>;
  odometer?: Maybe<Scalars['Int']['output']>;
  reference: Scalars['ID']['output'];
  rfidId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  timezoneOffsetMins?: Maybe<Scalars['Int']['output']>;
  trackingDriverRef?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  vehicleRef?: Maybe<Scalars['String']['output']>;
};

export type WebAccess = {
  __typename?: 'WebAccess';
  accountJobs?: Maybe<Scalars['String']['output']>;
  addAddresses?: Maybe<Scalars['String']['output']>;
  addCards?: Maybe<Scalars['String']['output']>;
  addContacts?: Maybe<Scalars['String']['output']>;
  addJobs?: Maybe<Scalars['String']['output']>;
  addJobsAdhoc?: Maybe<Scalars['String']['output']>;
  addJobsOthers?: Maybe<Scalars['String']['output']>;
  allowRequest?: Maybe<Scalars['String']['output']>;
  canRequest?: Maybe<Scalars['String']['output']>;
  cancelJobs?: Maybe<Scalars['String']['output']>;
  cancelJobsOthers?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  contactGroupRef?: Maybe<Scalars['String']['output']>;
  contactRef?: Maybe<Scalars['Int']['output']>;
  deleteAddresses?: Maybe<Scalars['String']['output']>;
  disableCards?: Maybe<Scalars['String']['output']>;
  disableContacts?: Maybe<Scalars['String']['output']>;
  editAddresses?: Maybe<Scalars['String']['output']>;
  editCards?: Maybe<Scalars['String']['output']>;
  editContacts?: Maybe<Scalars['String']['output']>;
  editJobs?: Maybe<Scalars['String']['output']>;
  editJobsOthers?: Maybe<Scalars['String']['output']>;
  maintainChildContacts?: Maybe<Scalars['String']['output']>;
  maintainContacts?: Maybe<Scalars['String']['output']>;
  maintainDepts?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
  viewAddresses?: Maybe<Scalars['String']['output']>;
  viewCards?: Maybe<Scalars['String']['output']>;
  viewContacts?: Maybe<Scalars['String']['output']>;
  viewJobsOthers?: Maybe<Scalars['String']['output']>;
};

export type WebReport = {
  __typename?: 'WebReport';
  account?: Maybe<Account>;
  accountRef?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  contactRef?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  htmlPath?: Maybe<Scalars['String']['output']>;
  noUpdate?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  reportType?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type WebTariff = {
  __typename?: 'WebTariff';
  accountRef?: Maybe<Scalars['String']['output']>;
  appImgUrl?: Maybe<Scalars['String']['output']>;
  appImgUrlUpdatedDt?: Maybe<Scalars['DelayLocalDateTimeResolver']['output']>;
  base64Icon?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  goodsType?: Maybe<Scalars['Int']['output']>;
  imgUrl?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  maxPassenger?: Maybe<Scalars['Int']['output']>;
  maxUnits?: Maybe<Scalars['Int']['output']>;
  priceGroup?: Maybe<Scalars['String']['output']>;
  reference: Scalars['ID']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  tariff?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  viewOnly?: Maybe<Scalars['String']['output']>;
  warningMsg?: Maybe<Scalars['String']['output']>;
};

export type GetAppDataQueryVariables = Exact<{
  codes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetAppDataQuery = { __typename?: 'Query', parameters: Array<{ __typename?: 'Parameter', code?: string | null, setting?: string | null }> };

export type GetUserProfileQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
}>;


export type GetUserProfileQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', reference: string, accountRef?: string | null, contactName?: string | null, email?: string | null, mobile?: string | null, telephone?: string | null } };

export type GetAccountDetailsQueryVariables = Exact<{
  reference: Scalars['String']['input'];
}>;


export type GetAccountDetailsQuery = { __typename?: 'Query', account: { __typename?: 'Account', reference: string, name?: string | null } };

export type GetUniversalAddressesPartialQueryVariables = Exact<{
  contactRef?: InputMaybe<Scalars['Int']['input']>;
  accountRef?: InputMaybe<Scalars['String']['input']>;
  partial?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetUniversalAddressesPartialQuery = { __typename?: 'Query', universalAddresses: Array<{ __typename?: 'AddressWithType', addressName?: string | null, address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, postcode?: string | null, country?: string | null, countryCode?: string | null, lat?: number | null, long?: number | null, gridX?: number | null, gridY?: number | null, reference: string, accountRef?: string | null, contactRef?: number | null, notes?: string | null, code?: string | null, searchAddress?: string | null, typeCode: string }> };

export type DefaultAddressesQueryVariables = Exact<{
  contactRef?: InputMaybe<Scalars['Int']['input']>;
  accountRef?: InputMaybe<Scalars['String']['input']>;
}>;


export type DefaultAddressesQuery = { __typename?: 'Query', defaultAddresses: { __typename?: 'AddressDefaults', account?: { __typename?: 'Address', reference: string, addressName?: string | null, address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, postcode?: string | null, country?: string | null, countryCode?: string | null, lat?: number | null, long?: number | null, gridX?: number | null, gridY?: number | null, code?: string | null, notes?: string | null, type?: { __typename?: 'AddressType', code?: string | null } | null } | null, contact?: { __typename?: 'Address', reference: string, addressName?: string | null, address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, postcode?: string | null, country?: string | null, countryCode?: string | null, lat?: number | null, long?: number | null, gridX?: number | null, gridY?: number | null, code?: string | null, notes?: string | null, type?: { __typename?: 'AddressType', code?: string | null } | null } | null } };

export type AddressQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
}>;


export type AddressQuery = { __typename?: 'Query', address: { __typename?: 'Address', addressName?: string | null, address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, postcode?: string | null, country?: string | null, countryCode?: string | null, lat?: number | null, long?: number | null, gridX?: number | null, gridY?: number | null, reference: string, code?: string | null, notes?: string | null, type?: { __typename?: 'AddressType', code?: string | null } | null } };

export type GetAddressByCodeQueryVariables = Exact<{
  addressCode: Scalars['String']['input'];
  contactRef?: InputMaybe<Scalars['Int']['input']>;
  accountRef?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAddressByCodeQuery = { __typename?: 'Query', addressByCode?: { __typename?: 'Address', addressName?: string | null, address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, postcode?: string | null, country?: string | null, countryCode?: string | null, lat?: number | null, long?: number | null, gridX?: number | null, gridY?: number | null, reference: string, code?: string | null, notes?: string | null, type?: { __typename?: 'AddressType', code?: string | null } | null } | null };

export type GetAccountExtraRefsQueryVariables = Exact<{
  reference: Scalars['String']['input'];
}>;


export type GetAccountExtraRefsQuery = { __typename?: 'Query', account: { __typename?: 'Account', reference: string, extraRefs: Array<{ __typename?: 'AccountExtraRef', allowDefaultValue?: string | null, allowedFormats?: string | null, compulsory?: string | null, defaultAccountDeptRef?: number | null, description?: string | null, disabled?: string | null, filterByGroups?: number | null, maxLength?: number | null, prompt?: string | null, reference: string, sortOrder?: number | null, validated?: string | null, webSearchDdl?: number | null, calculatedDefault?: string | null }> } };

export type GetContactExtraRefsQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
}>;


export type GetContactExtraRefsQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', reference: string, extraRefs: Array<{ __typename?: 'AccountExtraRef', allowDefaultValue?: string | null, allowedFormats?: string | null, compulsory?: string | null, defaultAccountDeptRef?: number | null, description?: string | null, disabled?: string | null, filterByGroups?: number | null, maxLength?: number | null, prompt?: string | null, reference: string, sortOrder?: number | null, validated?: string | null, webSearchDdl?: number | null, calculatedDefault?: string | null }> } };

export type GetExtraRefValuesQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
  accountExtraRefRef: Scalars['Int']['input'];
  partial?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetExtraRefValuesQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', extraRefValues: Array<{ __typename?: 'AccountDept', code?: string | null, description?: string | null, reference: string }> } };

export type GetJobDetailsQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  typeCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  accountRef: Scalars['String']['input'];
  contactRef: Scalars['Int']['input'];
  appName: Scalars['String']['input'];
  platformName: Scalars['String']['input'];
}>;


export type GetJobDetailsQuery = { __typename?: 'Query', job: { __typename?: 'Job', reference: string, cancelReason?: string | null, holdReason?: string | null, dateCompleted?: any | null, tariff?: string | null, prebook?: string | null, pickupDt?: any | null, pickupDate?: any | null, dateEntered?: any | null, enteredBy?: string | null, estJourneyTime?: number | null, status: string, normalisedEstPrice?: number | null, normalisedEstPriceVat?: number | null, normalisedEstPriceTotal?: number | null, currencyCode?: string | null, webInstructions?: string | null, contactRef?: number | null, contactName?: string | null, contactPhone?: string | null, contactMobile?: string | null, contactEmail?: string | null, eta?: string | null, otherRef?: string | null, accountDeptRef?: number | null, planGoods?: string | null, extraRefs: Array<{ __typename?: 'AccountExtraRef', reference: string, prompt?: string | null }>, jobExtraRefs: Array<{ __typename?: 'JobExtraRef', reference: string, accountExtraRefRef?: number | null, referenceValue?: string | null }>, jobExtras?: Array<{ __typename?: 'JobExtra', reference: string, description?: string | null, quantity?: number | null, unit?: string | null }> | null, stops: Array<{ __typename?: 'Stop', reference: string, dropOrder?: number | null, addressName?: string | null, address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, postcode?: string | null, country?: string | null, countryCode?: string | null, lat?: number | null, long?: number | null, gridX?: number | null, gridY?: number | null, notes?: string | null, requiredFromDt?: any | null, requiredToDt?: any | null, reqDtsManuallyEdited?: number | null, contactName?: string | null, contactTelephone?: string | null, contactMobile?: string | null, contactEmail?: string | null, asDirected: boolean, asDirectedTime?: number | null, asDirectedTimeUnit?: string | null, podImages: Array<{ __typename?: 'Picture', reference: string }> }>, goods: Array<{ __typename?: 'Good', reference: string, type?: number | null, description?: string | null, code?: string | null, code2?: string | null, info1?: string | null, info2?: string | null, info3?: string | null, unitWeight?: number | null, unitHeight?: number | null, unitWidth?: number | null, unitDepth?: number | null, unitValue?: number | null, unitCube?: number | null, unitCartons?: number | null, nonDoc?: number | null, dropStop?: number | null, pickupStop?: number | null, quantity?: number | null }>, displayedJobFlags?: Array<{ __typename?: 'Flag', reference: string, description?: string | null, sortOrder?: number | null }> | null, tariffDetail?: { __typename?: 'Tariff', description?: string | null } | null, webTariff?: { __typename?: 'WebTariff', label?: string | null, description?: string | null, appImgUrl?: string | null } | null, driver?: { __typename?: 'Driver', firstname?: string | null, surname?: string | null, telMobile?: string | null, oLicenceNumber?: string | null, photo?: { __typename?: 'Picture', picHeight?: number | null, picWidth?: number | null, dataUri?: string | null } | null } | null, vehicle?: { __typename?: 'Vehicle', registration?: string | null, vehicleClass?: string | null, vehicleColour?: string | null, description?: string | null } | null, tracking: Array<{ __typename?: 'VehicleMove', locationDt?: any | null, gridY?: number | null, gridX?: number | null, locationDir?: number | null, locationSpeed?: number | null, locationDesc?: string | null, timezoneOffsetMins?: number | null, locationDateTimeUtc?: any | null }>, oagFlightJob?: { __typename?: 'OagFlightJob', reference: string, jobRef?: number | null, arrival?: string | null, stopRef?: number | null, flightDt?: any | null, fromToCity?: string | null, flightCode?: string | null, statusEta?: string | null, departAirportCode?: string | null, arriveAirportCode?: string | null, holdOff?: number | null } | null, vouchers?: Array<{ __typename?: 'JobVoucher', voucherRef: number, voucherCode: string }> | null, customerVisibleDocuments?: Array<{ __typename?: 'Document', reference: string, description?: string | null, source?: string | null, documentType?: { __typename?: 'DocumentType', code?: string | null, description?: string | null } | null, documentObjs?: Array<{ __typename?: 'DocumentObj', reference: string, typeDesc?: string | null, typeCode?: string | null, sortOrder?: number | null }> | null }> | null } };

export type GetStopPodImagesQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
}>;


export type GetStopPodImagesQuery = { __typename?: 'Query', job: { __typename?: 'Job', stops: Array<{ __typename?: 'Stop', reference: string, podImages: Array<{ __typename?: 'Picture', reference: string, picName?: string | null, picWidth?: number | null, picHeight?: number | null, dataUri?: string | null }> }> } };

export type GetContactCardDetailsQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
}>;


export type GetContactCardDetailsQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', defaultContactCardRef?: number | null, contactCards: Array<{ __typename?: 'ContactCard', reference: string, lastFourCharacters?: string | null, cardTypeCode?: string | null, validFrom?: string | null, validTo?: string | null, nameOnCard?: string | null }> } };

export type GetJobDetailsForActionQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
}>;


export type GetJobDetailsForActionQuery = { __typename?: 'Query', job: { __typename?: 'Job', reference: string, tariff?: string | null, pickupDt?: any | null, prebook?: string | null, waitReturn?: string | null, webInstructions?: string | null, webInstructionsMaxLength: number, mop?: string | null, goodsQty?: number | null, contactRef?: number | null, contactName?: string | null, contactPhone?: string | null, contactMobile?: string | null, contactEmail?: string | null, invoiced?: string | null, holdReason?: string | null, dateCancelled?: any | null, arriveBy: boolean, jobFlags?: string | null, accountDept?: string | null, otherRef?: string | null, stops: Array<{ __typename?: 'Stop', reference: string, dropOrder?: number | null, addressName?: string | null, address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, postcode?: string | null, country?: string | null, countryCode?: string | null, lat?: number | null, long?: number | null, gridX?: number | null, gridY?: number | null, notes?: string | null, requiredFromDt?: any | null, requiredToDt?: any | null, reqDtsManuallyEdited?: number | null, contactName?: string | null, contactTelephone?: string | null, contactMobile?: string | null, contactEmail?: string | null, asDirected: boolean, asDirectedTime?: number | null, asDirectedTimeUnit?: string | null }>, goods: Array<{ __typename?: 'Good', reference: string, type?: number | null, description?: string | null, code?: string | null, code2?: string | null, info1?: string | null, info2?: string | null, info3?: string | null, unitWeight?: number | null, unitHeight?: number | null, unitWidth?: number | null, unitDepth?: number | null, unitValue?: number | null, unitCube?: number | null, unitCartons?: number | null, nonDoc?: number | null, dropStop?: number | null, pickupStop?: number | null, quantity?: number | null, goodsFlags: Array<{ __typename?: 'GoodsFlag', reference: string, description?: string | null, disabled?: string | null }> }>, jobExtraRefs: Array<{ __typename?: 'JobExtraRef', referenceValue?: string | null, accountExtraRefRef?: number | null }>, oagFlightJob?: { __typename?: 'OagFlightJob', stopRef?: number | null, flightCode?: string | null, fromToCity?: string | null, scheduledArrivalDt?: any | null, terminal?: string | null, arrival?: string | null, flightNo?: string | null, carrierCode?: string | null, scheduledDepartureDt?: any | null, departAirportCode?: string | null, arriveAirportCode?: string | null, holdOff?: number | null } | null, jobExtras?: Array<{ __typename?: 'JobExtra', code?: string | null, quantity?: number | null }> | null, vouchers?: Array<{ __typename?: 'JobVoucher', voucherRef: number, voucherCode: string }> | null, jobCards?: Array<{ __typename?: 'JobCard', reference: string, contactCard?: { __typename?: 'ContactCard', lastFourCharacters?: string | null } | null }> | null } };

export type GetJobQuoteQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
}>;


export type GetJobQuoteQuery = { __typename?: 'Query', jobquote: { __typename?: 'JobQuote', reference: string, tariff?: string | null, tariffRef?: number | null, jobRef?: number | null, pickupDt?: any | null, prebook?: string | null, waitReturn?: string | null, contactRef?: number | null, contactName?: string | null, webInstructions?: string | null, webInstructionsMaxLength: number, mop?: string | null, jobFlags?: string | null, accountDept?: string | null, otherRef?: string | null, jobQuoteStops: Array<{ __typename?: 'JobQuoteStop', reference: string, dropOrder?: number | null, addressName?: string | null, address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, postcode?: string | null, country?: string | null, countryCode?: string | null, lat?: number | null, long?: number | null, gridX?: number | null, gridY?: number | null, notes?: string | null, stopTime?: number | null }>, jobQuoteExtraRefs: Array<{ __typename?: 'JobQuoteExtraRef', referenceValue?: string | null, accountextrarefRef?: number | null }> } };

export type FavouriteJourneysQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FavouriteJourneysQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', favouriteJourneys: Array<{ __typename?: 'Job', reference: string, planGoods?: string | null, tariff?: string | null, waitReturn?: string | null, webInstructions?: string | null, webInstructionsMaxLength: number, mop?: string | null, goodsQty?: number | null, contactRef?: number | null, contactName?: string | null, contactPhone?: string | null, contactMobile?: string | null, contactEmail?: string | null, jobFlags?: string | null, accountDept?: string | null, otherRef?: string | null, webTariff?: { __typename?: 'WebTariff', label?: string | null, goodsType?: number | null } | null, stops: Array<{ __typename?: 'Stop', reference: string, dropOrder?: number | null, addressName?: string | null, address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, postcode?: string | null, country?: string | null, countryCode?: string | null, lat?: number | null, long?: number | null, gridX?: number | null, gridY?: number | null, notes?: string | null, requiredFromDt?: any | null, requiredToDt?: any | null, reqDtsManuallyEdited?: number | null, contactName?: string | null, contactTelephone?: string | null, contactMobile?: string | null, contactEmail?: string | null, asDirected: boolean, asDirectedTime?: number | null, asDirectedTimeUnit?: string | null }>, goods: Array<{ __typename?: 'Good', reference: string, type?: number | null, description?: string | null, code?: string | null, code2?: string | null, info1?: string | null, info2?: string | null, info3?: string | null, unitWeight?: number | null, unitHeight?: number | null, unitWidth?: number | null, unitDepth?: number | null, unitValue?: number | null, unitCube?: number | null, unitCartons?: number | null, nonDoc?: number | null, dropStop?: number | null, pickupStop?: number | null, goodsFlags: Array<{ __typename?: 'GoodsFlag', reference: string, description?: string | null, disabled?: string | null }> }>, jobExtraRefs: Array<{ __typename?: 'JobExtraRef', referenceValue?: string | null, accountExtraRefRef?: number | null }>, oagFlightJob?: { __typename?: 'OagFlightJob', stopRef?: number | null, flightCode?: string | null, fromToCity?: string | null, scheduledArrivalDt?: any | null, terminal?: string | null, arrival?: string | null, flightNo?: string | null, carrierCode?: string | null, scheduledDepartureDt?: any | null, departAirportCode?: string | null, arriveAirportCode?: string | null, holdOff?: number | null } | null }> } };

export type GetContactFavouriteJourneysQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetContactFavouriteJourneysQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', intJobFavourites: Array<{ __typename?: 'IntFavourite', reference: string, jobRef?: number | null, description?: string | null, job?: { __typename?: 'Job', reference: string, planGoods?: string | null, tariff?: string | null, waitReturn?: string | null, webInstructions?: string | null, webInstructionsMaxLength: number, mop?: string | null, goodsQty?: number | null, contactRef?: number | null, contactName?: string | null, contactPhone?: string | null, contactMobile?: string | null, contactEmail?: string | null, jobFlags?: string | null, accountDept?: string | null, otherRef?: string | null, webTariff?: { __typename?: 'WebTariff', label?: string | null, goodsType?: number | null } | null, stops: Array<{ __typename?: 'Stop', reference: string, dropOrder?: number | null, addressName?: string | null, address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, postcode?: string | null, country?: string | null, countryCode?: string | null, lat?: number | null, long?: number | null, gridX?: number | null, gridY?: number | null, notes?: string | null, requiredFromDt?: any | null, requiredToDt?: any | null, reqDtsManuallyEdited?: number | null, contactName?: string | null, contactTelephone?: string | null, contactMobile?: string | null, contactEmail?: string | null, asDirected: boolean, asDirectedTime?: number | null, asDirectedTimeUnit?: string | null }>, goods: Array<{ __typename?: 'Good', reference: string, type?: number | null, description?: string | null, code?: string | null, code2?: string | null, info1?: string | null, info2?: string | null, info3?: string | null, unitWeight?: number | null, unitHeight?: number | null, unitWidth?: number | null, unitDepth?: number | null, unitValue?: number | null, unitCube?: number | null, unitCartons?: number | null, nonDoc?: number | null, dropStop?: number | null, pickupStop?: number | null, goodsFlags: Array<{ __typename?: 'GoodsFlag', reference: string, description?: string | null, disabled?: string | null }> }>, jobExtraRefs: Array<{ __typename?: 'JobExtraRef', referenceValue?: string | null, accountExtraRefRef?: number | null }>, oagFlightJob?: { __typename?: 'OagFlightJob', stopRef?: number | null, flightCode?: string | null, fromToCity?: string | null, scheduledArrivalDt?: any | null, terminal?: string | null, arrival?: string | null, flightNo?: string | null, carrierCode?: string | null, scheduledDepartureDt?: any | null, departAirportCode?: string | null, arriveAirportCode?: string | null, holdOff?: number | null } | null } | null }> } };

export type GetContactMasqueradeCountsQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
}>;


export type GetContactMasqueradeCountsQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', bookForContactsCount: number, masqueradeAndMaintainContactsCount: number } };

export type GetBookForContactsQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
  partial?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetBookForContactsQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', bookForContacts: Array<{ __typename?: 'Contact', reference: string, accountRef?: string | null, contactName?: string | null, telephone?: string | null, mobile?: string | null, email?: string | null }> } };

export type GetMasqueradeAndMaintainContactsQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
  partial?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMasqueradeAndMaintainContactsQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', masqueradeAndMaintainContacts: Array<{ __typename?: 'Contact', reference: string, accountRef?: string | null, contactName?: string | null, telephone?: string | null, mobile?: string | null, email?: string | null }> } };

export type GetContactWebAccessQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
}>;


export type GetContactWebAccessQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', webAccess: { __typename?: 'WebAccess', reference: string, contactRef?: number | null, maintainContacts?: string | null, maintainChildContacts?: string | null, viewContacts?: string | null, editContacts?: string | null, disableContacts?: string | null, viewAddresses?: string | null, addAddresses?: string | null, editAddresses?: string | null, deleteAddresses?: string | null, viewCards?: string | null, addCards?: string | null, disableCards?: string | null, addJobs?: string | null, addJobsOthers?: string | null, editJobs?: string | null, editJobsOthers?: string | null, cancelJobs?: string | null, cancelJobsOthers?: string | null, canRequest?: string | null, maintainDepts?: string | null } } };

export type GetContactCalculatedDefaultsQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
}>;


export type GetContactCalculatedDefaultsQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', calculatedDefaultTariff?: string | null, calculatedDefaultJobFlags?: string | null, calculatedDefaultMop?: string | null } };

export type GetJobEmailsQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
}>;


export type GetJobEmailsQuery = { __typename?: 'Query', job: { __typename?: 'Job', reference: string, contactEmail?: string | null, bookerEmail?: string | null, goods: Array<{ __typename?: 'Good', info1?: string | null, info2?: string | null, info3?: string | null }> } };

export type GetJobAccessQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
  contactRef: Scalars['Int']['input'];
}>;


export type GetJobAccessQuery = { __typename?: 'Query', job: { __typename?: 'Job', contactHasAccess: boolean, isJobContact: boolean } };

export type GetJobFlagsQueryVariables = Exact<{
  flagIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetJobFlagsQuery = { __typename?: 'Query', flagsById?: Array<{ __typename?: 'Flag', flagId?: number | null, note?: string | null, disabled?: string | null }> | null };

export type GetGoodsFlagsQueryVariables = Exact<{
  flagRefs?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetGoodsFlagsQuery = { __typename?: 'Query', goodsFlagsByRef?: Array<{ __typename?: 'GoodsFlag', reference: string, disabled?: string | null, goodsType?: number | null }> | null };

export type GetVoucherRefByCodeQueryVariables = Exact<{
  voucherCode: Scalars['String']['input'];
}>;


export type GetVoucherRefByCodeQuery = { __typename?: 'Query', rewardRefByCode?: number | null };

export type AccountWebSettingsByAccountRefQueryVariables = Exact<{
  accountRef: Scalars['String']['input'];
}>;


export type AccountWebSettingsByAccountRefQuery = { __typename?: 'Query', account: { __typename?: 'Account', accountWebSetting: { __typename?: 'AccountWebSetting', priceIncTax?: string | null, defaultContactIsPassenger?: string | null, signupDefaultGroupRef?: number | null } } };

export type GetDocumentObjectQueryVariables = Exact<{
  reference: Scalars['Int']['input'];
}>;


export type GetDocumentObjectQuery = { __typename?: 'Query', documentobj: { __typename?: 'DocumentObj', reference: string, description?: string | null, dataUri?: string | null, typeCode?: string | null } };

export type GetAvailableCountriesOverrideQueryVariables = Exact<{
  accountRef: Scalars['String']['input'];
  contactRef?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAvailableCountriesOverrideQuery = { __typename?: 'Query', availableCountriesOverride: Array<{ __typename?: 'CountriesOverride', countryCode?: string | null, countryDescription?: string | null }> };

export type GetAvailableCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableCountriesQuery = { __typename?: 'Query', availableCountries: Array<{ __typename?: 'Country', iso2?: string | null, description?: string | null }> };

export type GetEarliestDelayQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEarliestDelayQuery = { __typename?: 'Query', earliestDelay?: number | null };

export type GetQuickQuoteAvailableQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuickQuoteAvailableQuery = { __typename?: 'Query', quickQuoteAvailable: boolean };


export const GetAppDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAppData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parameters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"setting"}}]}}]}}]} as unknown as DocumentNode<GetAppDataQuery, GetAppDataQueryVariables>;
export const GetUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"accountRef"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}}]}}]}}]} as unknown as DocumentNode<GetUserProfileQuery, GetUserProfileQueryVariables>;
export const GetAccountDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAccountDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>;
export const GetUniversalAddressesPartialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUniversalAddressesPartial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactRef"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountRef"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partial"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"universalAddresses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contactRef"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactRef"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountRef"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountRef"}}},{"kind":"Argument","name":{"kind":"Name","value":"partial"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partial"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"types"},"value":{"kind":"Variable","name":{"kind":"Name","value":"types"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressName"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"address3"}},{"kind":"Field","name":{"kind":"Name","value":"address4"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"gridX"}},{"kind":"Field","name":{"kind":"Name","value":"gridY"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"accountRef"}},{"kind":"Field","name":{"kind":"Name","value":"contactRef"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"searchAddress"}},{"kind":"Field","name":{"kind":"Name","value":"typeCode"}}]}}]}}]} as unknown as DocumentNode<GetUniversalAddressesPartialQuery, GetUniversalAddressesPartialQueryVariables>;
export const DefaultAddressesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"defaultAddresses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactRef"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountRef"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultAddresses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contactRef"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactRef"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountRef"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountRef"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"addressName"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"address3"}},{"kind":"Field","name":{"kind":"Name","value":"address4"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"gridX"}},{"kind":"Field","name":{"kind":"Name","value":"gridY"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"addressName"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"address3"}},{"kind":"Field","name":{"kind":"Name","value":"address4"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"gridX"}},{"kind":"Field","name":{"kind":"Name","value":"gridY"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DefaultAddressesQuery, DefaultAddressesQueryVariables>;
export const AddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Address"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressName"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"address3"}},{"kind":"Field","name":{"kind":"Name","value":"address4"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"gridX"}},{"kind":"Field","name":{"kind":"Name","value":"gridY"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<AddressQuery, AddressQueryVariables>;
export const GetAddressByCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAddressByCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactRef"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountRef"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressByCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"addressCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"contactRef"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactRef"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountRef"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountRef"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressName"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"address3"}},{"kind":"Field","name":{"kind":"Name","value":"address4"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"gridX"}},{"kind":"Field","name":{"kind":"Name","value":"gridY"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<GetAddressByCodeQuery, GetAddressByCodeQueryVariables>;
export const GetAccountExtraRefsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAccountExtraRefs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"extraRefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowDefaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"allowedFormats"}},{"kind":"Field","name":{"kind":"Name","value":"compulsory"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAccountDeptRef"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"filterByGroups"}},{"kind":"Field","name":{"kind":"Name","value":"maxLength"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"validated"}},{"kind":"Field","name":{"kind":"Name","value":"webSearchDdl"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedDefault"}}]}}]}}]}}]} as unknown as DocumentNode<GetAccountExtraRefsQuery, GetAccountExtraRefsQueryVariables>;
export const GetContactExtraRefsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getContactExtraRefs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"extraRefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowDefaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"allowedFormats"}},{"kind":"Field","name":{"kind":"Name","value":"compulsory"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAccountDeptRef"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"filterByGroups"}},{"kind":"Field","name":{"kind":"Name","value":"maxLength"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"validated"}},{"kind":"Field","name":{"kind":"Name","value":"webSearchDdl"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedDefault"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}]}]}}]}}]}}]} as unknown as DocumentNode<GetContactExtraRefsQuery, GetContactExtraRefsQueryVariables>;
export const GetExtraRefValuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getExtraRefValues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountExtraRefRef"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partial"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extraRefValues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountExtraRefRef"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountExtraRefRef"}}},{"kind":"Argument","name":{"kind":"Name","value":"partial"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partial"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}}]}}]}}]}}]} as unknown as DocumentNode<GetExtraRefValuesQuery, GetExtraRefValuesQueryVariables>;
export const GetJobDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getJobDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeCodes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountRef"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactRef"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"cancelReason"}},{"kind":"Field","name":{"kind":"Name","value":"holdReason"}},{"kind":"Field","name":{"kind":"Name","value":"dateCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"tariff"}},{"kind":"Field","name":{"kind":"Name","value":"prebook"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDt"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDate"}},{"kind":"Field","name":{"kind":"Name","value":"dateEntered"}},{"kind":"Field","name":{"kind":"Name","value":"enteredBy"}},{"kind":"Field","name":{"kind":"Name","value":"estJourneyTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"normalisedEstPrice"}},{"kind":"Field","name":{"kind":"Name","value":"normalisedEstPriceVat"}},{"kind":"Field","name":{"kind":"Name","value":"normalisedEstPriceTotal"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"webInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"contactRef"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhone"}},{"kind":"Field","name":{"kind":"Name","value":"contactMobile"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"otherRef"}},{"kind":"Field","name":{"kind":"Name","value":"accountDeptRef"}},{"kind":"Field","name":{"kind":"Name","value":"planGoods"}},{"kind":"Field","name":{"kind":"Name","value":"extraRefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobExtraRefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"accountExtraRefRef"}},{"kind":"Field","name":{"kind":"Name","value":"referenceValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobExtras"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"dropOrder"}},{"kind":"Field","name":{"kind":"Name","value":"addressName"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"address3"}},{"kind":"Field","name":{"kind":"Name","value":"address4"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"gridX"}},{"kind":"Field","name":{"kind":"Name","value":"gridY"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"requiredFromDt"}},{"kind":"Field","name":{"kind":"Name","value":"requiredToDt"}},{"kind":"Field","name":{"kind":"Name","value":"reqDtsManuallyEdited"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactTelephone"}},{"kind":"Field","name":{"kind":"Name","value":"contactMobile"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"asDirected"}},{"kind":"Field","name":{"kind":"Name","value":"asDirectedTime"}},{"kind":"Field","name":{"kind":"Name","value":"asDirectedTimeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"podImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"code2"}},{"kind":"Field","name":{"kind":"Name","value":"info1"}},{"kind":"Field","name":{"kind":"Name","value":"info2"}},{"kind":"Field","name":{"kind":"Name","value":"info3"}},{"kind":"Field","name":{"kind":"Name","value":"unitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"unitHeight"}},{"kind":"Field","name":{"kind":"Name","value":"unitWidth"}},{"kind":"Field","name":{"kind":"Name","value":"unitDepth"}},{"kind":"Field","name":{"kind":"Name","value":"unitValue"}},{"kind":"Field","name":{"kind":"Name","value":"unitCube"}},{"kind":"Field","name":{"kind":"Name","value":"unitCartons"}},{"kind":"Field","name":{"kind":"Name","value":"nonDoc"}},{"kind":"Field","name":{"kind":"Name","value":"dropStop"}},{"kind":"Field","name":{"kind":"Name","value":"pickupStop"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayedJobFlags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountRef"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountRef"}}},{"kind":"Argument","name":{"kind":"Name","value":"contactRef"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactRef"}}},{"kind":"Argument","name":{"kind":"Name","value":"appName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appName"}}},{"kind":"Argument","name":{"kind":"Name","value":"platformName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tariffDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"webTariff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"appImgUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"driver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"telMobile"}},{"kind":"Field","name":{"kind":"Name","value":"oLicenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"picHeight"}},{"kind":"Field","name":{"kind":"Name","value":"picWidth"}},{"kind":"Field","name":{"kind":"Name","value":"dataUri"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"}},{"kind":"Field","name":{"kind":"Name","value":"vehicleClass"}},{"kind":"Field","name":{"kind":"Name","value":"vehicleColour"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationDt"}},{"kind":"Field","name":{"kind":"Name","value":"gridY"}},{"kind":"Field","name":{"kind":"Name","value":"gridX"}},{"kind":"Field","name":{"kind":"Name","value":"locationDir"}},{"kind":"Field","name":{"kind":"Name","value":"locationSpeed"}},{"kind":"Field","name":{"kind":"Name","value":"locationDesc"}},{"kind":"Field","name":{"kind":"Name","value":"timezoneOffsetMins"}},{"kind":"Field","name":{"kind":"Name","value":"locationDateTimeUtc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"oagFlightJob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"jobRef"}},{"kind":"Field","name":{"kind":"Name","value":"arrival"}},{"kind":"Field","name":{"kind":"Name","value":"stopRef"}},{"kind":"Field","name":{"kind":"Name","value":"flightDt"}},{"kind":"Field","name":{"kind":"Name","value":"fromToCity"}},{"kind":"Field","name":{"kind":"Name","value":"flightCode"}},{"kind":"Field","name":{"kind":"Name","value":"statusEta"}},{"kind":"Field","name":{"kind":"Name","value":"departAirportCode"}},{"kind":"Field","name":{"kind":"Name","value":"arriveAirportCode"}},{"kind":"Field","name":{"kind":"Name","value":"holdOff"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vouchers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voucherRef"}},{"kind":"Field","name":{"kind":"Name","value":"voucherCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customerVisibleDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentObjs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"typeCodes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typeCodes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"typeDesc"}},{"kind":"Field","name":{"kind":"Name","value":"typeCode"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetJobDetailsQuery, GetJobDetailsQueryVariables>;
export const GetStopPodImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStopPodImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"podImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"picName"}},{"kind":"Field","name":{"kind":"Name","value":"picWidth"}},{"kind":"Field","name":{"kind":"Name","value":"picHeight"}},{"kind":"Field","name":{"kind":"Name","value":"dataUri"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetStopPodImagesQuery, GetStopPodImagesQueryVariables>;
export const GetContactCardDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getContactCardDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultContactCardRef"}},{"kind":"Field","name":{"kind":"Name","value":"contactCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"lastFourCharacters"}},{"kind":"Field","name":{"kind":"Name","value":"cardTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"nameOnCard"}}]}}]}}]}}]} as unknown as DocumentNode<GetContactCardDetailsQuery, GetContactCardDetailsQueryVariables>;
export const GetJobDetailsForActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getJobDetailsForAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"tariff"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDt"}},{"kind":"Field","name":{"kind":"Name","value":"prebook"}},{"kind":"Field","name":{"kind":"Name","value":"waitReturn"}},{"kind":"Field","name":{"kind":"Name","value":"webInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"webInstructionsMaxLength"}},{"kind":"Field","name":{"kind":"Name","value":"mop"}},{"kind":"Field","name":{"kind":"Name","value":"goodsQty"}},{"kind":"Field","name":{"kind":"Name","value":"contactRef"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhone"}},{"kind":"Field","name":{"kind":"Name","value":"contactMobile"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"invoiced"}},{"kind":"Field","name":{"kind":"Name","value":"holdReason"}},{"kind":"Field","name":{"kind":"Name","value":"dateCancelled"}},{"kind":"Field","name":{"kind":"Name","value":"arriveBy"}},{"kind":"Field","name":{"kind":"Name","value":"stops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"dropOrder"}},{"kind":"Field","name":{"kind":"Name","value":"addressName"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"address3"}},{"kind":"Field","name":{"kind":"Name","value":"address4"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"gridX"}},{"kind":"Field","name":{"kind":"Name","value":"gridY"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"requiredFromDt"}},{"kind":"Field","name":{"kind":"Name","value":"requiredToDt"}},{"kind":"Field","name":{"kind":"Name","value":"reqDtsManuallyEdited"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactTelephone"}},{"kind":"Field","name":{"kind":"Name","value":"contactMobile"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"asDirected"}},{"kind":"Field","name":{"kind":"Name","value":"asDirectedTime"}},{"kind":"Field","name":{"kind":"Name","value":"asDirectedTimeUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"code2"}},{"kind":"Field","name":{"kind":"Name","value":"info1"}},{"kind":"Field","name":{"kind":"Name","value":"info2"}},{"kind":"Field","name":{"kind":"Name","value":"info3"}},{"kind":"Field","name":{"kind":"Name","value":"unitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"unitHeight"}},{"kind":"Field","name":{"kind":"Name","value":"unitWidth"}},{"kind":"Field","name":{"kind":"Name","value":"unitDepth"}},{"kind":"Field","name":{"kind":"Name","value":"unitValue"}},{"kind":"Field","name":{"kind":"Name","value":"unitCube"}},{"kind":"Field","name":{"kind":"Name","value":"unitCartons"}},{"kind":"Field","name":{"kind":"Name","value":"nonDoc"}},{"kind":"Field","name":{"kind":"Name","value":"dropStop"}},{"kind":"Field","name":{"kind":"Name","value":"pickupStop"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"goodsFlags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobFlags"}},{"kind":"Field","name":{"kind":"Name","value":"accountDept"}},{"kind":"Field","name":{"kind":"Name","value":"otherRef"}},{"kind":"Field","name":{"kind":"Name","value":"jobExtraRefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceValue"}},{"kind":"Field","name":{"kind":"Name","value":"accountExtraRefRef"}}]}},{"kind":"Field","name":{"kind":"Name","value":"oagFlightJob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stopRef"}},{"kind":"Field","name":{"kind":"Name","value":"flightCode"}},{"kind":"Field","name":{"kind":"Name","value":"fromToCity"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledArrivalDt"}},{"kind":"Field","name":{"kind":"Name","value":"terminal"}},{"kind":"Field","name":{"kind":"Name","value":"arrival"}},{"kind":"Field","name":{"kind":"Name","value":"flightNo"}},{"kind":"Field","name":{"kind":"Name","value":"carrierCode"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledDepartureDt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledArrivalDt"}},{"kind":"Field","name":{"kind":"Name","value":"departAirportCode"}},{"kind":"Field","name":{"kind":"Name","value":"arriveAirportCode"}},{"kind":"Field","name":{"kind":"Name","value":"holdOff"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobExtras"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vouchers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voucherRef"}},{"kind":"Field","name":{"kind":"Name","value":"voucherCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"contactCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastFourCharacters"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetJobDetailsForActionQuery, GetJobDetailsForActionQueryVariables>;
export const GetJobQuoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getJobQuote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobquote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"tariff"}},{"kind":"Field","name":{"kind":"Name","value":"tariffRef"}},{"kind":"Field","name":{"kind":"Name","value":"jobRef"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDt"}},{"kind":"Field","name":{"kind":"Name","value":"prebook"}},{"kind":"Field","name":{"kind":"Name","value":"waitReturn"}},{"kind":"Field","name":{"kind":"Name","value":"contactRef"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"webInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"webInstructionsMaxLength"}},{"kind":"Field","name":{"kind":"Name","value":"mop"}},{"kind":"Field","name":{"kind":"Name","value":"jobFlags"}},{"kind":"Field","name":{"kind":"Name","value":"jobQuoteStops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"dropOrder"}},{"kind":"Field","name":{"kind":"Name","value":"addressName"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"address3"}},{"kind":"Field","name":{"kind":"Name","value":"address4"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"gridX"}},{"kind":"Field","name":{"kind":"Name","value":"gridY"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"stopTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountDept"}},{"kind":"Field","name":{"kind":"Name","value":"otherRef"}},{"kind":"Field","name":{"kind":"Name","value":"jobQuoteExtraRefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceValue"}},{"kind":"Field","name":{"kind":"Name","value":"accountextrarefRef"}}]}}]}}]}}]} as unknown as DocumentNode<GetJobQuoteQuery, GetJobQuoteQueryVariables>;
export const FavouriteJourneysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FavouriteJourneys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favouriteJourneys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"planGoods"}},{"kind":"Field","name":{"kind":"Name","value":"tariff"}},{"kind":"Field","name":{"kind":"Name","value":"waitReturn"}},{"kind":"Field","name":{"kind":"Name","value":"webInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"webInstructionsMaxLength"}},{"kind":"Field","name":{"kind":"Name","value":"mop"}},{"kind":"Field","name":{"kind":"Name","value":"goodsQty"}},{"kind":"Field","name":{"kind":"Name","value":"contactRef"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhone"}},{"kind":"Field","name":{"kind":"Name","value":"contactMobile"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"webTariff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"goodsType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"dropOrder"}},{"kind":"Field","name":{"kind":"Name","value":"addressName"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"address3"}},{"kind":"Field","name":{"kind":"Name","value":"address4"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"gridX"}},{"kind":"Field","name":{"kind":"Name","value":"gridY"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"requiredFromDt"}},{"kind":"Field","name":{"kind":"Name","value":"requiredToDt"}},{"kind":"Field","name":{"kind":"Name","value":"reqDtsManuallyEdited"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactTelephone"}},{"kind":"Field","name":{"kind":"Name","value":"contactMobile"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"asDirected"}},{"kind":"Field","name":{"kind":"Name","value":"asDirectedTime"}},{"kind":"Field","name":{"kind":"Name","value":"asDirectedTimeUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"code2"}},{"kind":"Field","name":{"kind":"Name","value":"info1"}},{"kind":"Field","name":{"kind":"Name","value":"info2"}},{"kind":"Field","name":{"kind":"Name","value":"info3"}},{"kind":"Field","name":{"kind":"Name","value":"unitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"unitHeight"}},{"kind":"Field","name":{"kind":"Name","value":"unitWidth"}},{"kind":"Field","name":{"kind":"Name","value":"unitDepth"}},{"kind":"Field","name":{"kind":"Name","value":"unitValue"}},{"kind":"Field","name":{"kind":"Name","value":"unitCube"}},{"kind":"Field","name":{"kind":"Name","value":"unitCartons"}},{"kind":"Field","name":{"kind":"Name","value":"nonDoc"}},{"kind":"Field","name":{"kind":"Name","value":"dropStop"}},{"kind":"Field","name":{"kind":"Name","value":"pickupStop"}},{"kind":"Field","name":{"kind":"Name","value":"goodsFlags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobFlags"}},{"kind":"Field","name":{"kind":"Name","value":"accountDept"}},{"kind":"Field","name":{"kind":"Name","value":"otherRef"}},{"kind":"Field","name":{"kind":"Name","value":"jobExtraRefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceValue"}},{"kind":"Field","name":{"kind":"Name","value":"accountExtraRefRef"}}]}},{"kind":"Field","name":{"kind":"Name","value":"oagFlightJob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stopRef"}},{"kind":"Field","name":{"kind":"Name","value":"flightCode"}},{"kind":"Field","name":{"kind":"Name","value":"fromToCity"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledArrivalDt"}},{"kind":"Field","name":{"kind":"Name","value":"terminal"}},{"kind":"Field","name":{"kind":"Name","value":"arrival"}},{"kind":"Field","name":{"kind":"Name","value":"flightNo"}},{"kind":"Field","name":{"kind":"Name","value":"carrierCode"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledDepartureDt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledArrivalDt"}},{"kind":"Field","name":{"kind":"Name","value":"departAirportCode"}},{"kind":"Field","name":{"kind":"Name","value":"arriveAirportCode"}},{"kind":"Field","name":{"kind":"Name","value":"holdOff"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FavouriteJourneysQuery, FavouriteJourneysQueryVariables>;
export const GetContactFavouriteJourneysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getContactFavouriteJourneys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intJobFavourites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"jobRef"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"planGoods"}},{"kind":"Field","name":{"kind":"Name","value":"tariff"}},{"kind":"Field","name":{"kind":"Name","value":"waitReturn"}},{"kind":"Field","name":{"kind":"Name","value":"webInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"webInstructionsMaxLength"}},{"kind":"Field","name":{"kind":"Name","value":"mop"}},{"kind":"Field","name":{"kind":"Name","value":"goodsQty"}},{"kind":"Field","name":{"kind":"Name","value":"contactRef"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhone"}},{"kind":"Field","name":{"kind":"Name","value":"contactMobile"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"webTariff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"goodsType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"dropOrder"}},{"kind":"Field","name":{"kind":"Name","value":"addressName"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"address3"}},{"kind":"Field","name":{"kind":"Name","value":"address4"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"gridX"}},{"kind":"Field","name":{"kind":"Name","value":"gridY"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"requiredFromDt"}},{"kind":"Field","name":{"kind":"Name","value":"requiredToDt"}},{"kind":"Field","name":{"kind":"Name","value":"reqDtsManuallyEdited"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactTelephone"}},{"kind":"Field","name":{"kind":"Name","value":"contactMobile"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"asDirected"}},{"kind":"Field","name":{"kind":"Name","value":"asDirectedTime"}},{"kind":"Field","name":{"kind":"Name","value":"asDirectedTimeUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"code2"}},{"kind":"Field","name":{"kind":"Name","value":"info1"}},{"kind":"Field","name":{"kind":"Name","value":"info2"}},{"kind":"Field","name":{"kind":"Name","value":"info3"}},{"kind":"Field","name":{"kind":"Name","value":"unitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"unitHeight"}},{"kind":"Field","name":{"kind":"Name","value":"unitWidth"}},{"kind":"Field","name":{"kind":"Name","value":"unitDepth"}},{"kind":"Field","name":{"kind":"Name","value":"unitValue"}},{"kind":"Field","name":{"kind":"Name","value":"unitCube"}},{"kind":"Field","name":{"kind":"Name","value":"unitCartons"}},{"kind":"Field","name":{"kind":"Name","value":"nonDoc"}},{"kind":"Field","name":{"kind":"Name","value":"dropStop"}},{"kind":"Field","name":{"kind":"Name","value":"pickupStop"}},{"kind":"Field","name":{"kind":"Name","value":"goodsFlags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobFlags"}},{"kind":"Field","name":{"kind":"Name","value":"accountDept"}},{"kind":"Field","name":{"kind":"Name","value":"otherRef"}},{"kind":"Field","name":{"kind":"Name","value":"jobExtraRefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceValue"}},{"kind":"Field","name":{"kind":"Name","value":"accountExtraRefRef"}}]}},{"kind":"Field","name":{"kind":"Name","value":"oagFlightJob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stopRef"}},{"kind":"Field","name":{"kind":"Name","value":"flightCode"}},{"kind":"Field","name":{"kind":"Name","value":"fromToCity"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledArrivalDt"}},{"kind":"Field","name":{"kind":"Name","value":"terminal"}},{"kind":"Field","name":{"kind":"Name","value":"arrival"}},{"kind":"Field","name":{"kind":"Name","value":"flightNo"}},{"kind":"Field","name":{"kind":"Name","value":"carrierCode"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledDepartureDt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledArrivalDt"}},{"kind":"Field","name":{"kind":"Name","value":"departAirportCode"}},{"kind":"Field","name":{"kind":"Name","value":"arriveAirportCode"}},{"kind":"Field","name":{"kind":"Name","value":"holdOff"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetContactFavouriteJourneysQuery, GetContactFavouriteJourneysQueryVariables>;
export const GetContactMasqueradeCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getContactMasqueradeCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookForContactsCount"}},{"kind":"Field","name":{"kind":"Name","value":"masqueradeAndMaintainContactsCount"}}]}}]}}]} as unknown as DocumentNode<GetContactMasqueradeCountsQuery, GetContactMasqueradeCountsQueryVariables>;
export const GetBookForContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBookForContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partial"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookForContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"partial"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partial"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"accountRef"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<GetBookForContactsQuery, GetBookForContactsQueryVariables>;
export const GetMasqueradeAndMaintainContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMasqueradeAndMaintainContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partial"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"masqueradeAndMaintainContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"partial"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partial"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"accountRef"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<GetMasqueradeAndMaintainContactsQuery, GetMasqueradeAndMaintainContactsQueryVariables>;
export const GetContactWebAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getContactWebAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"contactRef"}},{"kind":"Field","name":{"kind":"Name","value":"maintainContacts"}},{"kind":"Field","name":{"kind":"Name","value":"maintainChildContacts"}},{"kind":"Field","name":{"kind":"Name","value":"viewContacts"}},{"kind":"Field","name":{"kind":"Name","value":"editContacts"}},{"kind":"Field","name":{"kind":"Name","value":"disableContacts"}},{"kind":"Field","name":{"kind":"Name","value":"viewAddresses"}},{"kind":"Field","name":{"kind":"Name","value":"addAddresses"}},{"kind":"Field","name":{"kind":"Name","value":"editAddresses"}},{"kind":"Field","name":{"kind":"Name","value":"deleteAddresses"}},{"kind":"Field","name":{"kind":"Name","value":"viewCards"}},{"kind":"Field","name":{"kind":"Name","value":"addCards"}},{"kind":"Field","name":{"kind":"Name","value":"disableCards"}},{"kind":"Field","name":{"kind":"Name","value":"addJobs"}},{"kind":"Field","name":{"kind":"Name","value":"addJobsOthers"}},{"kind":"Field","name":{"kind":"Name","value":"editJobs"}},{"kind":"Field","name":{"kind":"Name","value":"editJobsOthers"}},{"kind":"Field","name":{"kind":"Name","value":"cancelJobs"}},{"kind":"Field","name":{"kind":"Name","value":"cancelJobsOthers"}},{"kind":"Field","name":{"kind":"Name","value":"canRequest"}},{"kind":"Field","name":{"kind":"Name","value":"maintainDepts"}}]}}]}}]}}]} as unknown as DocumentNode<GetContactWebAccessQuery, GetContactWebAccessQueryVariables>;
export const GetContactCalculatedDefaultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getContactCalculatedDefaults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatedDefaultTariff"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedDefaultJobFlags"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedDefaultMop"}}]}}]}}]} as unknown as DocumentNode<GetContactCalculatedDefaultsQuery, GetContactCalculatedDefaultsQueryVariables>;
export const GetJobEmailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getJobEmails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"bookerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"goods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"info1"}},{"kind":"Field","name":{"kind":"Name","value":"info2"}},{"kind":"Field","name":{"kind":"Name","value":"info3"}}]}}]}}]}}]} as unknown as DocumentNode<GetJobEmailsQuery, GetJobEmailsQueryVariables>;
export const GetJobAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getJobAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactRef"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactHasAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contactRef"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactRef"}}}]},{"kind":"Field","name":{"kind":"Name","value":"isJobContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contactRef"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactRef"}}}]}]}}]}}]} as unknown as DocumentNode<GetJobAccessQuery, GetJobAccessQueryVariables>;
export const GetJobFlagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getJobFlags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flagIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flagsById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"flagIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flagIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flagId"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}}]}}]}}]} as unknown as DocumentNode<GetJobFlagsQuery, GetJobFlagsQueryVariables>;
export const GetGoodsFlagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getGoodsFlags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flagRefs"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goodsFlagsByRef"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"flagRefs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flagRefs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"goodsType"}}]}}]}}]} as unknown as DocumentNode<GetGoodsFlagsQuery, GetGoodsFlagsQueryVariables>;
export const GetVoucherRefByCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getVoucherRefByCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"voucherCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewardRefByCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"voucherCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"voucherCode"}}}]}]}}]} as unknown as DocumentNode<GetVoucherRefByCodeQuery, GetVoucherRefByCodeQueryVariables>;
export const AccountWebSettingsByAccountRefDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountWebSettingsByAccountRef"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountRef"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountRef"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountWebSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceIncTax"}},{"kind":"Field","name":{"kind":"Name","value":"defaultContactIsPassenger"}},{"kind":"Field","name":{"kind":"Name","value":"signupDefaultGroupRef"}}]}}]}}]}}]} as unknown as DocumentNode<AccountWebSettingsByAccountRefQuery, AccountWebSettingsByAccountRefQueryVariables>;
export const GetDocumentObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocumentObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentobj"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"dataUri"}},{"kind":"Field","name":{"kind":"Name","value":"typeCode"}}]}}]}}]} as unknown as DocumentNode<GetDocumentObjectQuery, GetDocumentObjectQueryVariables>;
export const GetAvailableCountriesOverrideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAvailableCountriesOverride"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountRef"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactRef"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableCountriesOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountRef"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountRef"}}},{"kind":"Argument","name":{"kind":"Name","value":"contactRef"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactRef"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryDescription"}}]}}]}}]} as unknown as DocumentNode<GetAvailableCountriesOverrideQuery, GetAvailableCountriesOverrideQueryVariables>;
export const GetAvailableCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAvailableCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iso2"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GetAvailableCountriesQuery, GetAvailableCountriesQueryVariables>;
export const GetEarliestDelayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEarliestDelay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"earliestDelay"}}]}}]} as unknown as DocumentNode<GetEarliestDelayQuery, GetEarliestDelayQueryVariables>;
export const GetQuickQuoteAvailableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getQuickQuoteAvailable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quickQuoteAvailable"}}]}}]} as unknown as DocumentNode<GetQuickQuoteAvailableQuery, GetQuickQuoteAvailableQueryVariables>;